


//working before dynamic

// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//     useEffect(() => {
//         const fetchManager = async () => {
//             if (userData?.dept) {
//                 try {
//                     const response = await fetch(`/gt-api/get_manager_by_dept.php?dept=${userData.dept}`);
//                     const data = await response.json();
//                     if (data.success) {
//                         setAssignedManagerId(data.managerEmpId);
//                     }
//                 } catch (err) {
//                     console.error("Manager routing failed", err);
//                 }
//             }
//         };
//         fetchManager();
//     }, [userData?.dept]);

//     // --- PROBATION CALCULATION ---
//     useEffect(() => {
//         if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate]);


//     const fetchHistory = useCallback(async () => {
//         if (!employeeId) return;

//         try {
//             const response = await fetch(`/gt-api/get_leaves.php?empid=${employeeId}`);
//             const data = await response.json();

//             if (data.success) {

//                 const allLeaves = data.leaves || [];

//                 // Full history (used for leave balance calculation)
//                 setLeaveHistory(allLeaves);

//                 // Filter only for Application Log (after 10 March 2026)
//                 const cutoffDate = new Date("2026-03-10");

//                 const filteredLogs = allLeaves.filter(leave => {
//                     const leaveDate = new Date(leave.PostingDate);
//                     return leaveDate >= cutoffDate;
//                 });

//                 setDisplayLogs(filteredLogs);

//                 setDbEarnedCount(parseFloat(data.earned) || 0);
//             }

//         } catch (e) {
//             console.error("Fetch history failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//     const handleFileUpload = async (e, leaveId) => {
//         const file = e.target.files[0];
//         if (!file) return;
//         const formData = new FormData();
//         formData.append('medical_doc', file);
//         formData.append('leave_id', leaveId);
//         formData.append('empid', employeeId);

//         try {
//             setIsSubmitting(true);
//             const response = await fetch("/gt-api/upload_medical.php", { method: "POST", body: formData });
//             const result = await response.json();
//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'File uploaded! Waiting for Admin verification.', type: 'success' });
//                 fetchHistory();
//             }
//         } catch (err) {
//             setModal({ show: true, title: 'ERROR', message: 'Upload failed.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };

//     // const PUBLIC_HOLIDAYS = [
//     //     '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//     //     '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     // ];

//     // const isWorkDay = (date) => {
//     //     const day = date.getDay();
//     //     const dateString = date.toISOString().split('T')[0];
//     //     const isWeekend = (day === 0 || day === 6);
//     //     const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//     //     return !isWeekend && !isHoliday;
//     // };




//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             if (isProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {
//             // const response = await fetch("/gt-api/apply_leave.php", { method: "POST", body: formData });
//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         if (leaveForm.type === 'Sick Leave' && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 2: Your Original Logic (Unchanged) ---
//         let finalLeaveType = leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave' && deduction > 2) {
//             let modalMessage = "";
//             if (isBackdatedReq) {
//                 if (!medicalFile) {
//                     modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                 } else {
//                     modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                 }
//             } else {
//                 modalMessage = `You have applied for ${deduction} Days. Policy says Sick leave more than 2 days will automatically be considered as Earned Leave. After your leave ends, you will have 48 hours to upload medical documentation. If Document is approved, it reverts to Sick Leave. Do you want to Proceed?`;
//             }

//             setModal({
//                 show: true,
//                 title: 'LEAVE POLICY NOTICE',
//                 message: modalMessage,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//         } else {
//             submitToDB(finalLeaveType);
//         }
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDeleteLeave = (id) => {
//         setModal({
//             show: true, title: 'CONFIRM_DELETE', message: 'Remove this request?', type: 'query',
//             action: async (choice) => {
//                 if (choice) {
//                     try {
//                         await fetch(`/gt-api/delete_leave.php?id=${id}`, { method: 'GET' });
//                         fetchHistory(); setModal({ show: false });
//                     } catch (err) { setModal({ show: true, title: 'ERROR', message: 'Failed.', type: 'error' }); }
//                 } else { setModal({ show: false }); }
//             }
//         });
//     };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isProbation) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;



















// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//   useEffect(() => {
//     const fetchManager = async () => {
//         if (userData?.dept) {
//             try {
//                 const response = await fetch(
//                     `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
//                     {
//                         credentials: "include"
//                     }
//                 );

//                 const data = await response.json();

//                 if (data.success) {
//                     setAssignedManagerId(data.managerEmpId);
//                 }

//             } catch (err) {
//                 console.error("Manager routing failed", err);
//             }
//         }
//     };

//     fetchManager();

// }, [userData?.dept]);
//     // --- PROBATION CALCULATION ---
//     useEffect(() => {
//         if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate]);


// const fetchHistory = useCallback(async () => {
//     if (!employeeId) return;

//     try {
//         const response = await fetch(
//             `/gt-api/get_leaves.php?empid=${employeeId}`,
//             {
//                 credentials: "include"
//             }
//         );

//         const data = await response.json();

//         if (data.success) {

//             const allLeaves = data.leaves || [];

//             // Full history
//             setLeaveHistory(allLeaves);

//             // Filter only for Application Log
//             const cutoffDate = new Date("2026-03-10");

//             const filteredLogs = allLeaves.filter(leave => {
//                 const leaveDate = new Date(leave.PostingDate);
//                 return leaveDate >= cutoffDate;
//             });

//             setDisplayLogs(filteredLogs);

//             setDbEarnedCount(parseFloat(data.earned) || 0);
//         }

//     } catch (e) {
//         console.error("Fetch history failed");
//     }

// }, [employeeId]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//    const handleFileUpload = async (e, leaveId) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const formData = new FormData();
//     formData.append('medical_doc', file);
//     formData.append('leave_id', leaveId);
//     formData.append('empid', employeeId);

//     try {
//         setIsSubmitting(true);

//         const response = await fetch(
//             "/gt-api/upload_medical.php",
//             {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             }
//         );

//         const result = await response.json();

//         if (result.success) {
//             setModal({
//                 show: true,
//                 title: 'SUCCESS',
//                 message: 'File uploaded! Waiting for Admin verification.',
//                 type: 'success'
//             });

//             fetchHistory();
//         }

//     } catch (err) {
//         setModal({
//             show: true,
//             title: 'ERROR',
//             message: 'Upload failed.',
//             type: 'error'
//         });

//     } finally {
//         setIsSubmitting(false);
//     }
// };
//     // const PUBLIC_HOLIDAYS = [
//     //     '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//     //     '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     // ];

//     // const isWorkDay = (date) => {
//     //     const day = date.getDay();
//     //     const dateString = date.toISOString().split('T')[0];
//     //     const isWeekend = (day === 0 || day === 6);
//     //     const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//     //     return !isWeekend && !isHoliday;
//     // };




//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             if (isProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {
          
//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         if (leaveForm.type === 'Sick Leave' && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 2: Your Original Logic (Unchanged) ---
//         let finalLeaveType = leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave' && deduction > 2) {
//             let modalMessage = "";
//             if (isBackdatedReq) {
//                 if (!medicalFile) {
//                     modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                 } else {
//                     modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                 }
//             } else {
//                 modalMessage = `You have applied for ${deduction} Days. Policy says Sick leave more than 2 days will automatically be considered as Earned Leave. After your leave ends, you will have 48 hours to upload medical documentation. If Document is approved, it reverts to Sick Leave. Do you want to Proceed?`;
//             }

//             setModal({
//                 show: true,
//                 title: 'LEAVE POLICY NOTICE',
//                 message: modalMessage,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//         } else {
//             submitToDB(finalLeaveType);
//         }
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//   const handleDeleteLeave = (id) => {
//     setModal({
//         show: true,
//         title: 'CONFIRM_DELETE',
//         message: 'Remove this request?',
//         type: 'query',
//         action: async (choice) => {
//             if (choice) {
//                 try {
//                     await fetch(
//                         `/gt-api/delete_leave.php?id=${id}`,
//                         {
//                             method: 'GET',
//                             credentials: 'include'
//                         }
//                     );

//                     fetchHistory();
//                     setModal({ show: false });

//                 } catch (err) {
//                     setModal({
//                         show: true,
//                         title: 'ERROR',
//                         message: 'Failed.',
//                         type: 'error'
//                     });
//                 }
//             } else {
//                 setModal({ show: false });
//             }
//         }
//     });
// };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isProbation) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;











































// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };

//     const POLICY_EFFECTIVE_DATE = "2026-08-26";

//     // --- RECALCULATE SICK LEAVE CONTINUOUS POLICY (CLIENT HELPER) ---
//     const recalculateSickLeavePolicy = useCallback((leaves) => {
//         if (!leaves || !Array.isArray(leaves)) return leaves || [];

//         const updatedLeaves = leaves.map(l => ({ ...l }));
//         const approvedLeaves = updatedLeaves.filter(l => String(l.Status) === "1");

//         const sickDateMap = {};
//         const approvedSickLeavesMap = {};

//         approvedLeaves.forEach(l => {
//             const lId = l.id || l.leave_id;
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));

//             if (isSick && l.fromdate && l.todate) {
//                 approvedSickLeavesMap[lId] = { leave: l, isConverted };
//                 let cur = new Date(l.fromdate);
//                 const end = new Date(l.todate);

//                 while (cur <= end) {
//                     const dStr = cur.toISOString().split("T")[0];
//                     if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                     sickDateMap[dStr].push(lId);
//                     cur.setDate(cur.getDate() + 1);
//                 }
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return updatedLeaves;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaveIds: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaveIds: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         clusters.forEach(cluster => {
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaveIds.forEach(id => {
//                         const lObj = approvedSickLeavesMap[id];
//                         if (lObj) clusterLeavesMap[id] = lObj.leave;
//                     });
//                 }
//             });

//             let totalSickDays = 0;
//             Object.values(clusterLeavesMap).forEach(l => {
//                 const days = parseFloat(l.total);
//                 if (!isNaN(days) && days > 0) {
//                     totalSickDays += days;
//                 } else {
//                     let dCount = 0;
//                     let curD = new Date(l.fromdate);
//                     const endD = new Date(l.todate);
//                     while (curD <= endD) {
//                         if (isWorkDay(curD)) dCount++;
//                         curD.setDate(curD.getDate() + 1);
//                     }
//                     totalSickDays += dCount;
//                 }
//             });

//             const shouldConvert = totalSickDays > 2;

//             Object.keys(clusterLeavesMap).forEach(id => {
//                 const targetLeave = updatedLeaves.find(l => String(l.id || l.leave_id) === String(id));
//                 if (targetLeave) {
//                     const isEligibleForPolicy = targetLeave.fromdate && targetLeave.fromdate >= POLICY_EFFECTIVE_DATE;
//                     if (shouldConvert && isEligibleForPolicy) {
//                         targetLeave.leavetype = "Earned Leave";
//                     } else if (approvedSickLeavesMap[id]?.isConverted) {
//                         targetLeave.leavetype = "Sick Leave";
//                     }
//                 }
//             });
//         });

//         return updatedLeaves;
//     }, []);

//     // --- HELPER TO CHECK CONTINUOUS SICK LEAVE NOTICE FOR NEW REQUEST ---
//     const checkContinuousSickLeaveNotice = useCallback((newStart, newEnd, currentDeduction, leavesHistory) => {
//         if (!newStart || !newEnd) return null;
//         if (newStart < POLICY_EFFECTIVE_DATE) return null;

//         const existingSickLeaves = (leavesHistory || []).filter(l => {
//             const status = String(l.Status);
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));
//             const isEligible = l.fromdate && l.fromdate >= POLICY_EFFECTIVE_DATE;
//             return isSick && isEligible && (status === "1" || status === "0" || status === "null");
//         });

//         const newReq = {
//             id: "NEW_DRAFT_REQ",
//             fromdate: newStart,
//             todate: newEnd,
//             leavetype: "Sick Leave",
//             Status: "1",
//             total: currentDeduction,
//             isNew: true
//         };

//         const allLeavesToTest = [...existingSickLeaves, newReq];

//         const sickDateMap = {};
//         allLeavesToTest.forEach(l => {
//             let cur = new Date(l.fromdate);
//             const end = new Date(l.todate);
//             while (cur <= end) {
//                 const dStr = cur.toISOString().split("T")[0];
//                 if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                 sickDateMap[dStr].push(l);
//                 cur.setDate(cur.getDate() + 1);
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return null;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaves: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaves: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         for (const cluster of clusters) {
//             let hasNewReq = false;
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaves.forEach(l => {
//                         const key = l.isNew ? "NEW_DRAFT" : (l.id || l.leave_id || `${l.fromdate}_${l.todate}`);
//                         clusterLeavesMap[key] = l;
//                         if (l.isNew) hasNewReq = true;
//                     });
//                 }
//             });

//             if (hasNewReq) {
//                 let totalSickDays = 0;
//                 const prevRequests = [];

//                 Object.values(clusterLeavesMap).forEach(l => {
//                     if (l.isNew) {
//                         totalSickDays += parseFloat(currentDeduction) || 0;
//                     } else {
//                         const days = parseFloat(l.total);
//                         if (!isNaN(days) && days > 0) {
//                             totalSickDays += days;
//                         } else {
//                             let dCount = 0;
//                             let curD = new Date(l.fromdate);
//                             const endD = new Date(l.todate);
//                             while (curD <= endD) {
//                                 if (isWorkDay(curD)) dCount++;
//                                 curD.setDate(curD.getDate() + 1);
//                             }
//                             totalSickDays += dCount;
//                         }
//                         prevRequests.push(l);
//                     }
//                 });

//                 if (totalSickDays > 2) {
//                     return {
//                         totalSickDays: totalSickDays,
//                         prevRequests: prevRequests,
//                         newStart,
//                         newEnd
//                     };
//                 }
//             }
//         }

//         return null;
//     }, []);



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//     useEffect(() => {
//         const fetchManager = async () => {
//             if (userData?.dept) {
//                 try {
//                     const response = await fetch(
//                         `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
//                         {
//                             credentials: "include"
//                         }
//                     );

//                     const data = await response.json();

//                     if (data.success) {
//                         setAssignedManagerId(data.managerEmpId);
//                     }

//                 } catch (err) {
//                     console.error("Manager routing failed", err);
//                 }
//             }
//         };

//         fetchManager();

//     }, [userData?.dept]);
//     // --- PROBATION CALCULATION ---
//     useEffect(() => {
//         if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate]);


//     const fetchHistory = useCallback(async () => {
//         if (!employeeId) return;

//         try {
//             const response = await fetch(
//                 `/gt-api/get_leaves.php?empid=${employeeId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {

//                 const rawLeaves = data.leaves || [];
//                 const allLeaves = recalculateSickLeavePolicy(rawLeaves);

//                 // Full history
//                 setLeaveHistory(allLeaves);

//                 // Filter only for Application Log
//                 const cutoffDate = new Date("2026-03-10");

//                 const filteredLogs = allLeaves.filter(leave => {
//                     const leaveDate = new Date(leave.PostingDate);
//                     return leaveDate >= cutoffDate;
//                 });

//                 setDisplayLogs(filteredLogs);

//                 setDbEarnedCount(parseFloat(data.earned) || 0);
//             }

//         } catch (e) {
//             console.error("Fetch history failed");
//         }

//     }, [employeeId, recalculateSickLeavePolicy]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//     const handleFileUpload = async (e, leaveId) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append('medical_doc', file);
//         formData.append('leave_id', leaveId);
//         formData.append('empid', employeeId);

//         try {
//             setIsSubmitting(true);

//             const response = await fetch(
//                 "/gt-api/upload_medical.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     body: formData
//                 }
//             );

//             const result = await response.json();

//             if (result.success) {
//                 setModal({
//                     show: true,
//                     title: 'SUCCESS',
//                     message: 'File uploaded! Waiting for Admin verification.',
//                     type: 'success'
//                 });

//                 fetchHistory();
//             }

//         } catch (err) {
//             setModal({
//                 show: true,
//                 title: 'ERROR',
//                 message: 'Upload failed.',
//                 type: 'error'
//             });

//         } finally {
//             setIsSubmitting(false);
//         }
//     };
//     // const PUBLIC_HOLIDAYS = [
//     //     '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//     //     '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     // ];

//     // const isWorkDay = (date) => {
//     //     const day = date.getDay();
//     //     const dateString = date.toISOString().split('T')[0];
//     //     const isWeekend = (day === 0 || day === 6);
//     //     const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//     //     return !isWeekend && !isHoliday;
//     // };




//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             if (isProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {

//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         if (leaveForm.type === 'Sick Leave' && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 2: Your Original Logic (Unchanged) ---
//         let finalLeaveType = leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave') {
//             const continuousInfo = checkContinuousSickLeaveNotice(leaveForm.start, leaveForm.end, deduction, leaveHistory);

//             if (continuousInfo) {
//                 let modalMessage = "";
//                 if (continuousInfo.prevRequests && continuousInfo.prevRequests.length > 0) {
//                     const prevStr = continuousInfo.prevRequests.map(p => `${p.fromdate} to ${p.todate}`).join(", ");
//                     modalMessage = `Your previous leave request was from ${prevStr}. If this request (${leaveForm.start} to ${leaveForm.end}) is approved, your continuous leave period will total ${continuousInfo.totalSickDays} Sick Leave day(s), which will be converted as Earned Leave with a total deduction of ${continuousInfo.totalSickDays} day(s). Do you want to proceed?`;
//                 } else if (isBackdatedReq) {
//                     if (!medicalFile) {
//                         modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                     } else {
//                         modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                     }
//                 } else {
//                     modalMessage = `You have applied for ${deduction} Days. Policy says continuous Sick leave of more than 2 days (Total: ${continuousInfo.totalSickDays} day(s)) will automatically be converted as Earned Leave once approved. Do you want to Proceed?`;
//                 }

//                 setModal({
//                     show: true,
//                     title: 'CONTINUOUS SICK LEAVE NOTICE',
//                     message: modalMessage,
//                     type: 'query',
//                     action: (choice) => {
//                         if (choice) {
//                             setModal({ show: false });
//                             submitToDB('Sick Leave');
//                         } else {
//                             setModal({ show: false });
//                         }
//                     }
//                 });
//                 return;
//             }
//         }

//         submitToDB(finalLeaveType);
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDeleteLeave = (id) => {
//         setModal({
//             show: true,
//             title: 'CONFIRM_DELETE',
//             message: 'Remove this request?',
//             type: 'query',
//             action: async (choice) => {
//                 if (choice) {
//                     try {
//                         await fetch(
//                             `/gt-api/delete_leave.php?id=${id}`,
//                             {
//                                 method: 'GET',
//                                 credentials: 'include'
//                             }
//                         );

//                         fetchHistory();
//                         setModal({ show: false });

//                     } catch (err) {
//                         setModal({
//                             show: true,
//                             title: 'ERROR',
//                             message: 'Failed.',
//                             type: 'error'
//                         });
//                     }
//                 } else {
//                     setModal({ show: false });
//                 }
//             }
//         });
//     };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isProbation) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;
















































// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };

//     const POLICY_EFFECTIVE_DATE = "2026-08-26";

//     // --- RECALCULATE SICK LEAVE CONTINUOUS POLICY (CLIENT HELPER) ---
//     const recalculateSickLeavePolicy = useCallback((leaves) => {
//         if (!leaves || !Array.isArray(leaves)) return leaves || [];

//         const updatedLeaves = leaves.map(l => ({ ...l }));
//         const approvedLeaves = updatedLeaves.filter(l => String(l.Status) === "1");

//         const sickDateMap = {};
//         const approvedSickLeavesMap = {};

//         approvedLeaves.forEach(l => {
//             const lId = l.id || l.leave_id;
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));

//             if (isSick && l.fromdate && l.todate) {
//                 approvedSickLeavesMap[lId] = { leave: l, isConverted };
//                 let cur = new Date(l.fromdate);
//                 const end = new Date(l.todate);

//                 while (cur <= end) {
//                     const dStr = cur.toISOString().split("T")[0];
//                     if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                     sickDateMap[dStr].push(lId);
//                     cur.setDate(cur.getDate() + 1);
//                 }
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return updatedLeaves;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaveIds: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaveIds: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         clusters.forEach(cluster => {
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaveIds.forEach(id => {
//                         const lObj = approvedSickLeavesMap[id];
//                         if (lObj) clusterLeavesMap[id] = lObj.leave;
//                     });
//                 }
//             });

//             let totalSickDays = 0;
//             Object.values(clusterLeavesMap).forEach(l => {
//                 const days = parseFloat(l.total);
//                 if (!isNaN(days) && days > 0) {
//                     totalSickDays += days;
//                 } else {
//                     let dCount = 0;
//                     let curD = new Date(l.fromdate);
//                     const endD = new Date(l.todate);
//                     while (curD <= endD) {
//                         if (isWorkDay(curD)) dCount++;
//                         curD.setDate(curD.getDate() + 1);
//                     }
//                     totalSickDays += dCount;
//                 }
//             });

//             const shouldConvert = totalSickDays > 2;

//             Object.keys(clusterLeavesMap).forEach(id => {
//                 const targetLeave = updatedLeaves.find(l => String(l.id || l.leave_id) === String(id));
//                 if (targetLeave) {
//                     const isEligibleForPolicy = targetLeave.fromdate && targetLeave.fromdate >= POLICY_EFFECTIVE_DATE;
//                     if (shouldConvert && isEligibleForPolicy) {
//                         targetLeave.leavetype = "Earned Leave";
//                     } else if (approvedSickLeavesMap[id]?.isConverted) {
//                         targetLeave.leavetype = "Sick Leave";
//                     }
//                 }
//             });
//         });

//         return updatedLeaves;
//     }, []);

//     // --- HELPER TO CHECK CONTINUOUS SICK LEAVE NOTICE FOR NEW REQUEST ---
//     const checkContinuousSickLeaveNotice = useCallback((newStart, newEnd, currentDeduction, leavesHistory) => {
//         if (!newStart || !newEnd) return null;
//         if (newStart < POLICY_EFFECTIVE_DATE) return null;

//         const existingSickLeaves = (leavesHistory || []).filter(l => {
//             const status = String(l.Status);
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));
//             const isEligible = l.fromdate && l.fromdate >= POLICY_EFFECTIVE_DATE;
//             return isSick && isEligible && (status === "1" || status === "0" || status === "null");
//         });

//         const newReq = {
//             id: "NEW_DRAFT_REQ",
//             fromdate: newStart,
//             todate: newEnd,
//             leavetype: "Sick Leave",
//             Status: "1",
//             total: currentDeduction,
//             isNew: true
//         };

//         const allLeavesToTest = [...existingSickLeaves, newReq];

//         const sickDateMap = {};
//         allLeavesToTest.forEach(l => {
//             let cur = new Date(l.fromdate);
//             const end = new Date(l.todate);
//             while (cur <= end) {
//                 const dStr = cur.toISOString().split("T")[0];
//                 if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                 sickDateMap[dStr].push(l);
//                 cur.setDate(cur.getDate() + 1);
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return null;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaves: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaves: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         for (const cluster of clusters) {
//             let hasNewReq = false;
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaves.forEach(l => {
//                         const key = l.isNew ? "NEW_DRAFT" : (l.id || l.leave_id || `${l.fromdate}_${l.todate}`);
//                         clusterLeavesMap[key] = l;
//                         if (l.isNew) hasNewReq = true;
//                     });
//                 }
//             });

//             if (hasNewReq) {
//                 let totalSickDays = 0;
//                 const prevRequests = [];

//                 Object.values(clusterLeavesMap).forEach(l => {
//                     if (l.isNew) {
//                         totalSickDays += parseFloat(currentDeduction) || 0;
//                     } else {
//                         const days = parseFloat(l.total);
//                         if (!isNaN(days) && days > 0) {
//                             totalSickDays += days;
//                         } else {
//                             let dCount = 0;
//                             let curD = new Date(l.fromdate);
//                             const endD = new Date(l.todate);
//                             while (curD <= endD) {
//                                 if (isWorkDay(curD)) dCount++;
//                                 curD.setDate(curD.getDate() + 1);
//                             }
//                             totalSickDays += dCount;
//                         }
//                         prevRequests.push(l);
//                     }
//                 });

//                 if (totalSickDays > 2) {
//                     return {
//                         totalSickDays: totalSickDays,
//                         prevRequests: prevRequests,
//                         newStart,
//                         newEnd
//                     };
//                 }
//             }
//         }

//         return null;
//     }, []);



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//     useEffect(() => {
//         const fetchManager = async () => {
//             if (userData?.dept) {
//                 try {
//                     const response = await fetch(
//                         `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
//                         {
//                             credentials: "include"
//                         }
//                     );

//                     const data = await response.json();

//                     if (data.success) {
//                         setAssignedManagerId(data.managerEmpId);
//                     }

//                 } catch (err) {
//                     console.error("Manager routing failed", err);
//                 }
//             }
//         };

//         fetchManager();

//     }, [userData?.dept]);
//     // --- PROBATION CALCULATION ---
//     useEffect(() => {
//         if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate]);


//     const fetchHistory = useCallback(async () => {
//         if (!employeeId) return;

//         try {
//             const response = await fetch(
//                 `/gt-api/get_leaves.php?empid=${employeeId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {

//                 const rawLeaves = data.leaves || [];
//                 const allLeaves = recalculateSickLeavePolicy(rawLeaves);

//                 // Full history
//                 setLeaveHistory(allLeaves);

//                 // Filter only for Application Log
//                 const cutoffDate = new Date("2026-03-10");

//                 const filteredLogs = allLeaves.filter(leave => {
//                     const leaveDate = new Date(leave.PostingDate);
//                     return leaveDate >= cutoffDate;
//                 });

//                 setDisplayLogs(filteredLogs);

//                 setDbEarnedCount(parseFloat(data.earned) || 0);
//             }

//         } catch (e) {
//             console.error("Fetch history failed");
//         }

//     }, [employeeId, recalculateSickLeavePolicy]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//     const handleFileUpload = async (e, leaveId) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append('medical_doc', file);
//         formData.append('leave_id', leaveId);
//         formData.append('empid', employeeId);

//         try {
//             setIsSubmitting(true);

//             const response = await fetch(
//                 "/gt-api/upload_medical.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     body: formData
//                 }
//             );

//             const result = await response.json();

//             if (result.success) {
//                 setModal({
//                     show: true,
//                     title: 'SUCCESS',
//                     message: 'File uploaded! Waiting for Admin verification.',
//                     type: 'success'
//                 });

//                 fetchHistory();
//             }

//         } catch (err) {
//             setModal({
//                 show: true,
//                 title: 'ERROR',
//                 message: 'Upload failed.',
//                 type: 'error'
//             });

//         } finally {
//             setIsSubmitting(false);
//         }
//     };
   


//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             if (isProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {

//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         // Only enforce sick quota limit for standard sick leave (deduction <= 2)
//         if (leaveForm.type === 'Sick Leave' && deduction <= 2 && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 2: Your Original Logic (Unchanged) ---
//         const isSingleSickOverTwo = (leaveForm.type === 'Sick Leave' && deduction > 2);
//         let finalLeaveType = isSingleSickOverTwo ? 'Earned Leave' : leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave') {
//             const continuousInfo = checkContinuousSickLeaveNotice(leaveForm.start, leaveForm.end, deduction, leaveHistory);

//             if (continuousInfo) {
//                 let modalMessage = "";
//                 if (continuousInfo.prevRequests && continuousInfo.prevRequests.length > 0) {
//                     const prevStr = continuousInfo.prevRequests.map(p => `${p.fromdate} to ${p.todate}`).join(", ");
//                     modalMessage = `Your previous leave request was from ${prevStr}. If this request (${leaveForm.start} to ${leaveForm.end}) is approved, your continuous leave period will total ${continuousInfo.totalSickDays} Sick Leave day(s), which will be converted as Earned Leave with a total deduction of ${continuousInfo.totalSickDays} day(s). Do you want to proceed?`;
//                 } else if (isBackdatedReq) {
//                     if (!medicalFile) {
//                         modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                     } else {
//                         modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                     }
//                 } else {
//                     modalMessage = `You have applied for ${deduction} Days. Policy says continuous Sick leave of more than 2 days (Total: ${continuousInfo.totalSickDays} day(s)) will automatically be converted as Earned Leave once approved. Do you want to Proceed?`;
//                 }

//                 setModal({
//                     show: true,
//                     title: 'CONTINUOUS SICK LEAVE NOTICE',
//                     message: modalMessage,
//                     type: 'query',
//                     action: (choice) => {
//                         if (choice) {
//                             setModal({ show: false });
//                             // For a single standalone request > 2 days, submit directly as Earned Leave
//                             // For separate consecutive requests <= 2 days, submit as Sick Leave (converted only post-approval)
//                             if (deduction > 2) {
//                                 submitToDB('Earned Leave');
//                             } else {
//                                 submitToDB('Sick Leave');
//                             }
//                         } else {
//                             setModal({ show: false });
//                         }
//                     }
//                 });
//                 return;
//             }
//         }

//         submitToDB(finalLeaveType);
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDeleteLeave = (id) => {
//         setModal({
//             show: true,
//             title: 'CONFIRM_DELETE',
//             message: 'Remove this request?',
//             type: 'query',
//             action: async (choice) => {
//                 if (choice) {
//                     try {
//                         await fetch(
//                             `/gt-api/delete_leave.php?id=${id}`,
//                             {
//                                 method: 'GET',
//                                 credentials: 'include'
//                             }
//                         );

//                         fetchHistory();
//                         setModal({ show: false });

//                     } catch (err) {
//                         setModal({
//                             show: true,
//                             title: 'ERROR',
//                             message: 'Failed.',
//                             type: 'error'
//                         });
//                     }
//                 } else {
//                     setModal({ show: false });
//                 }
//             }
//         });
//     };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isProbation) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;













































// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };

//     const POLICY_EFFECTIVE_DATE = "2026-08-26";

//     // --- RECALCULATE SICK LEAVE CONTINUOUS POLICY (CLIENT HELPER) ---
//     const recalculateSickLeavePolicy = useCallback((leaves) => {
//         if (!leaves || !Array.isArray(leaves)) return leaves || [];

//         const updatedLeaves = leaves.map(l => ({ ...l }));
//         const approvedLeaves = updatedLeaves.filter(l => String(l.Status) === "1");

//         const sickDateMap = {};
//         const approvedSickLeavesMap = {};

//         approvedLeaves.forEach(l => {
//             const lId = l.id || l.leave_id;
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));

//             if (isSick && l.fromdate && l.todate) {
//                 approvedSickLeavesMap[lId] = { leave: l, isConverted };
//                 let cur = new Date(l.fromdate);
//                 const end = new Date(l.todate);

//                 while (cur <= end) {
//                     const dStr = cur.toISOString().split("T")[0];
//                     if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                     sickDateMap[dStr].push(lId);
//                     cur.setDate(cur.getDate() + 1);
//                 }
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return updatedLeaves;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaveIds: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaveIds: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         clusters.forEach(cluster => {
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaveIds.forEach(id => {
//                         const lObj = approvedSickLeavesMap[id];
//                         if (lObj) clusterLeavesMap[id] = lObj.leave;
//                     });
//                 }
//             });

//             let totalSickDays = 0;
//             Object.values(clusterLeavesMap).forEach(l => {
//                 const days = parseFloat(l.total);
//                 if (!isNaN(days) && days > 0) {
//                     totalSickDays += days;
//                 } else {
//                     let dCount = 0;
//                     let curD = new Date(l.fromdate);
//                     const endD = new Date(l.todate);
//                     while (curD <= endD) {
//                         if (isWorkDay(curD)) dCount++;
//                         curD.setDate(curD.getDate() + 1);
//                     }
//                     totalSickDays += dCount;
//                 }
//             });

//             const shouldConvert = totalSickDays > 2;

//             Object.keys(clusterLeavesMap).forEach(id => {
//                 const targetLeave = updatedLeaves.find(l => String(l.id || l.leave_id) === String(id));
//                 if (targetLeave) {
//                     const isEligibleForPolicy = targetLeave.fromdate && targetLeave.fromdate >= POLICY_EFFECTIVE_DATE;
//                     if (shouldConvert && isEligibleForPolicy) {
//                         targetLeave.leavetype = "Earned Leave";
//                     } else if (approvedSickLeavesMap[id]?.isConverted) {
//                         targetLeave.leavetype = "Sick Leave";
//                     }
//                 }
//             });
//         });

//         return updatedLeaves;
//     }, []);

//     // --- HELPER TO CHECK CONTINUOUS SICK LEAVE NOTICE FOR NEW REQUEST ---
//     const checkContinuousSickLeaveNotice = useCallback((newStart, newEnd, currentDeduction, leavesHistory) => {
//         if (!newStart || !newEnd) return null;
//         if (newStart < POLICY_EFFECTIVE_DATE) return null;

//         const existingSickLeaves = (leavesHistory || []).filter(l => {
//             const status = String(l.Status);
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));
//             const isEligible = l.fromdate && l.fromdate >= POLICY_EFFECTIVE_DATE;
//             return isSick && isEligible && (status === "1" || status === "0" || status === "null");
//         });

//         const newReq = {
//             id: "NEW_DRAFT_REQ",
//             fromdate: newStart,
//             todate: newEnd,
//             leavetype: "Sick Leave",
//             Status: "1",
//             total: currentDeduction,
//             isNew: true
//         };

//         const allLeavesToTest = [...existingSickLeaves, newReq];

//         const sickDateMap = {};
//         allLeavesToTest.forEach(l => {
//             let cur = new Date(l.fromdate);
//             const end = new Date(l.todate);
//             while (cur <= end) {
//                 const dStr = cur.toISOString().split("T")[0];
//                 if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                 sickDateMap[dStr].push(l);
//                 cur.setDate(cur.getDate() + 1);
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return null;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaves: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaves: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         for (const cluster of clusters) {
//             let hasNewReq = false;
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaves.forEach(l => {
//                         const key = l.isNew ? "NEW_DRAFT" : (l.id || l.leave_id || `${l.fromdate}_${l.todate}`);
//                         clusterLeavesMap[key] = l;
//                         if (l.isNew) hasNewReq = true;
//                     });
//                 }
//             });

//             if (hasNewReq) {
//                 let totalSickDays = 0;
//                 const prevRequests = [];

//                 Object.values(clusterLeavesMap).forEach(l => {
//                     if (l.isNew) {
//                         totalSickDays += parseFloat(currentDeduction) || 0;
//                     } else {
//                         const days = parseFloat(l.total);
//                         if (!isNaN(days) && days > 0) {
//                             totalSickDays += days;
//                         } else {
//                             let dCount = 0;
//                             let curD = new Date(l.fromdate);
//                             const endD = new Date(l.todate);
//                             while (curD <= endD) {
//                                 if (isWorkDay(curD)) dCount++;
//                                 curD.setDate(curD.getDate() + 1);
//                             }
//                             totalSickDays += dCount;
//                         }
//                         prevRequests.push(l);
//                     }
//                 });

//                 if (totalSickDays > 2) {
//                     return {
//                         totalSickDays: totalSickDays,
//                         prevRequests: prevRequests,
//                         newStart,
//                         newEnd
//                     };
//                 }
//             }
//         }

//         return null;
//     }, []);



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//     useEffect(() => {
//         const fetchManager = async () => {
//             if (userData?.dept) {
//                 try {
//                     const response = await fetch(
//                         `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
//                         {
//                             credentials: "include"
//                         }
//                     );

//                     const data = await response.json();

//                     if (data.success) {
//                         setAssignedManagerId(data.managerEmpId);
//                     }

//                 } catch (err) {
//                     console.error("Manager routing failed", err);
//                 }
//             }
//         };

//         fetchManager();

//     }, [userData?.dept]);
//     // --- PROBATION CALCULATION ---
//     const isLeaveInProbation = useCallback((startDate) => {
//         if (!userData?.joiningDate || !startDate) return false;
//         const joinDate = new Date(userData.joiningDate);
//         const probationEndDate = new Date(joinDate);
//         probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//         return new Date(startDate) < probationEndDate;
//     }, [userData?.joiningDate]);

//     useEffect(() => {
//         if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate]);


//     const fetchHistory = useCallback(async () => {
//         if (!employeeId) return;

//         try {
//             const response = await fetch(
//                 `/gt-api/get_leaves.php?empid=${employeeId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {

//                 const rawLeaves = data.leaves || [];
//                 const allLeaves = recalculateSickLeavePolicy(rawLeaves);

//                 // Full history
//                 setLeaveHistory(allLeaves);

//                 // Filter only for Application Log
//                 const cutoffDate = new Date("2026-03-10");

//                 const filteredLogs = allLeaves.filter(leave => {
//                     const leaveDate = new Date(leave.PostingDate);
//                     return leaveDate >= cutoffDate;
//                 });

//                 setDisplayLogs(filteredLogs);

//                 setDbEarnedCount(parseFloat(data.earned) || 0);
//             }

//         } catch (e) {
//             console.error("Fetch history failed");
//         }

//     }, [employeeId, recalculateSickLeavePolicy]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//     const handleFileUpload = async (e, leaveId) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append('medical_doc', file);
//         formData.append('leave_id', leaveId);
//         formData.append('empid', employeeId);

//         try {
//             setIsSubmitting(true);

//             const response = await fetch(
//                 "/gt-api/upload_medical.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     body: formData
//                 }
//             );

//             const result = await response.json();

//             if (result.success) {
//                 setModal({
//                     show: true,
//                     title: 'SUCCESS',
//                     message: 'File uploaded! Waiting for Admin verification.',
//                     type: 'success'
//                 });

//                 fetchHistory();
//             }

//         } catch (err) {
//             setModal({
//                 show: true,
//                 title: 'ERROR',
//                 message: 'Upload failed.',
//                 type: 'error'
//             });

//         } finally {
//             setIsSubmitting(false);
//         }
//     };
   


//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);

//             if (isThisLeaveInProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isLeaveInProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isThisLeaveInProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {

//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         // Only enforce sick quota limit for standard sick leave (deduction <= 2)
//         if (leaveForm.type === 'Sick Leave' && deduction <= 2 && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isThisLeaveInProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 3: Your Original Logic (Unchanged) ---
//         const isSingleSickOverTwo = (leaveForm.type === 'Sick Leave' && deduction > 2);
//         let finalLeaveType = isSingleSickOverTwo ? 'Earned Leave' : leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isThisLeaveInProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave') {
//             const continuousInfo = checkContinuousSickLeaveNotice(leaveForm.start, leaveForm.end, deduction, leaveHistory);

//             if (continuousInfo) {
//                 let modalMessage = "";
//                 if (continuousInfo.prevRequests && continuousInfo.prevRequests.length > 0) {
//                     const prevStr = continuousInfo.prevRequests.map(p => `${p.fromdate} to ${p.todate}`).join(", ");
//                     modalMessage = `Your previous leave request was from ${prevStr}. If this request (${leaveForm.start} to ${leaveForm.end}) is approved, your continuous leave period will total ${continuousInfo.totalSickDays} Sick Leave day(s), which will be converted as Earned Leave with a total deduction of ${continuousInfo.totalSickDays} day(s). Do you want to proceed?`;
//                 } else if (isBackdatedReq) {
//                     if (!medicalFile) {
//                         modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                     } else {
//                         modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                     }
//                 } else {
//                     modalMessage = `You have applied for ${deduction} Days. Policy says continuous Sick leave of more than 2 days (Total: ${continuousInfo.totalSickDays} day(s)) will automatically be converted as Earned Leave once approved. Do you want to Proceed?`;
//                 }

//                 setModal({
//                     show: true,
//                     title: 'CONTINUOUS SICK LEAVE NOTICE',
//                     message: modalMessage,
//                     type: 'query',
//                     action: (choice) => {
//                         if (choice) {
//                             setModal({ show: false });
//                             // For a single standalone request > 2 days, submit directly as Earned Leave
//                             // For separate consecutive requests <= 2 days, submit as Sick Leave (converted only post-approval)
//                             if (deduction > 2) {
//                                 submitToDB('Earned Leave');
//                             } else {
//                                 submitToDB('Sick Leave');
//                             }
//                         } else {
//                             setModal({ show: false });
//                         }
//                     }
//                 });
//                 return;
//             }
//         }

//         submitToDB(finalLeaveType);
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDeleteLeave = (id) => {
//         setModal({
//             show: true,
//             title: 'CONFIRM_DELETE',
//             message: 'Remove this request?',
//             type: 'query',
//             action: async (choice) => {
//                 if (choice) {
//                     try {
//                         await fetch(
//                             `/gt-api/delete_leave.php?id=${id}`,
//                             {
//                                 method: 'GET',
//                                 credentials: 'include'
//                             }
//                         );

//                         fetchHistory();
//                         setModal({ show: false });

//                     } catch (err) {
//                         setModal({
//                             show: true,
//                             title: 'ERROR',
//                             message: 'Failed.',
//                             type: 'error'
//                         });
//                     }
//                 } else {
//                     setModal({ show: false });
//                 }
//             }
//         });
//     };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isLeaveInProbation(leaveForm.start)) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;





























// import React, { useState, useEffect, useCallback, useRef } from "react";
// // import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';

// import '../styles/Attendance.css';

// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';

// const Attendance = ({ employeeId, userData }) => {
//     const navigate = useNavigate();
//     // --- 1. STATE MANAGEMENT ---
//     const [leaveBalances, setLeaveBalances] = useState({
//         sick: { used: 0, total: 12 },
//         earned: { used: 0, total: 0 }
//     });

//     const [calendarKey, setCalendarKey] = useState(0);
//     const calendarRef = useRef(null);
//     const [dbEarnedCount, setDbEarnedCount] = useState(0);
//     const [isProbation, setIsProbation] = useState(false);
//     const [isHalfDay, setIsHalfDay] = useState(null);
//     const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
//     const [leaveHistory, setLeaveHistory] = useState([]);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [displayLogs, setDisplayLogs] = useState([]);
//     const [deduction, setDeduction] = useState(0);
//     const [penaltyMsg, setPenaltyMsg] = useState("");
//     const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

//     const [medicalFile, setMedicalFile] = useState(null);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [assignedManagerId, setAssignedManagerId] = useState(null);


//     const startRef = useRef(null);
//     const endRef = useRef(null);



//     const fetchWFH = useCallback(async () => {

//         if (!employeeId) return;

//         try {

//             const res = await fetch(
//                 `/gt-api/get_wfh.php?empid=${employeeId}`,
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {
//                 setWfhHistory(data.requests || []);
//             }

//         } catch (err) {
//             console.error("WFH fetch failed");
//         }

//     }, [employeeId]);

//     useEffect(() => {
//         fetchWFH();
//     }, [fetchWFH]);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const isWorkDay = (date) => {
//         const day = date.getDay();
//         const dateString = date.toISOString().split('T')[0];
//         const isWeekend = (day === 0 || day === 6);
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
//         return !isWeekend && !isHoliday;
//     };

//     const POLICY_EFFECTIVE_DATE = "2026-08-26";

//     // --- RECALCULATE SICK LEAVE CONTINUOUS POLICY (CLIENT HELPER) ---
//     const recalculateSickLeavePolicy = useCallback((leaves) => {
//         if (!leaves || !Array.isArray(leaves)) return leaves || [];

//         const updatedLeaves = leaves.map(l => ({ ...l }));
//         const approvedLeaves = updatedLeaves.filter(l => String(l.Status) === "1");

//         const sickDateMap = {};
//         const approvedSickLeavesMap = {};

//         approvedLeaves.forEach(l => {
//             const lId = l.id || l.leave_id;
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));

//             if (isSick && l.fromdate && l.todate) {
//                 approvedSickLeavesMap[lId] = { leave: l, isConverted };
//                 let cur = new Date(l.fromdate);
//                 const end = new Date(l.todate);

//                 while (cur <= end) {
//                     const dStr = cur.toISOString().split("T")[0];
//                     if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                     sickDateMap[dStr].push(lId);
//                     cur.setDate(cur.getDate() + 1);
//                 }
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return updatedLeaves;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaveIds: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaveIds: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         clusters.forEach(cluster => {
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaveIds.forEach(id => {
//                         const lObj = approvedSickLeavesMap[id];
//                         if (lObj) clusterLeavesMap[id] = lObj.leave;
//                     });
//                 }
//             });

//             let totalSickDays = 0;
//             Object.values(clusterLeavesMap).forEach(l => {
//                 const days = parseFloat(l.total);
//                 if (!isNaN(days) && days > 0) {
//                     totalSickDays += days;
//                 } else {
//                     let dCount = 0;
//                     let curD = new Date(l.fromdate);
//                     const endD = new Date(l.todate);
//                     while (curD <= endD) {
//                         if (isWorkDay(curD)) dCount++;
//                         curD.setDate(curD.getDate() + 1);
//                     }
//                     totalSickDays += dCount;
//                 }
//             });

//             const shouldConvert = totalSickDays > 2;

//             Object.keys(clusterLeavesMap).forEach(id => {
//                 const targetLeave = updatedLeaves.find(l => String(l.id || l.leave_id) === String(id));
//                 if (targetLeave) {
//                     const isEligibleForPolicy = targetLeave.fromdate && targetLeave.fromdate >= POLICY_EFFECTIVE_DATE;
//                     if (shouldConvert && isEligibleForPolicy) {
//                         targetLeave.leavetype = "Earned Leave";
//                     } else if (approvedSickLeavesMap[id]?.isConverted) {
//                         targetLeave.leavetype = "Sick Leave";
//                     }
//                 }
//             });
//         });

//         return updatedLeaves;
//     }, []);

//     // --- HELPER TO CHECK CONTINUOUS SICK LEAVE NOTICE FOR NEW REQUEST ---
//     const checkContinuousSickLeaveNotice = useCallback((newStart, newEnd, currentDeduction, leavesHistory) => {
//         if (!newStart || !newEnd) return null;
//         if (newStart < POLICY_EFFECTIVE_DATE) return null;

//         const existingSickLeaves = (leavesHistory || []).filter(l => {
//             const status = String(l.Status);
//             const lType = (l.leavetype || l.LeaveType || "").trim();
//             const lRemark = l.AdminRemark || l.description || "";
//             const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
//             const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));
//             const isEligible = l.fromdate && l.fromdate >= POLICY_EFFECTIVE_DATE;
//             return isSick && isEligible && (status === "1" || status === "0" || status === "null");
//         });

//         const newReq = {
//             id: "NEW_DRAFT_REQ",
//             fromdate: newStart,
//             todate: newEnd,
//             leavetype: "Sick Leave",
//             Status: "1",
//             total: currentDeduction,
//             isNew: true
//         };

//         const allLeavesToTest = [...existingSickLeaves, newReq];

//         const sickDateMap = {};
//         allLeavesToTest.forEach(l => {
//             let cur = new Date(l.fromdate);
//             const end = new Date(l.todate);
//             while (cur <= end) {
//                 const dStr = cur.toISOString().split("T")[0];
//                 if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
//                 sickDateMap[dStr].push(l);
//                 cur.setDate(cur.getDate() + 1);
//             }
//         });

//         const sortedDates = Object.keys(sickDateMap).sort();
//         if (sortedDates.length === 0) return null;

//         const minDate = new Date(sortedDates[0]);
//         const maxDate = new Date(sortedDates[sortedDates.length - 1]);

//         const clusters = [];
//         let currentCluster = [];

//         let cur = new Date(minDate);
//         while (cur <= maxDate) {
//             const dStr = cur.toISOString().split("T")[0];
//             const hasSick = Boolean(sickDateMap[dStr]);
//             const workday = isWorkDay(cur);

//             if (hasSick) {
//                 currentCluster.push({ date: dStr, type: "SICK", leaves: sickDateMap[dStr] });
//             } else if (!workday) {
//                 if (currentCluster.length > 0) {
//                     currentCluster.push({ date: dStr, type: "BRIDGE", leaves: [] });
//                 }
//             } else {
//                 if (currentCluster.length > 0) {
//                     while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                         currentCluster.pop();
//                     }
//                     if (currentCluster.length > 0) clusters.push(currentCluster);
//                     currentCluster = [];
//                 }
//             }
//             cur.setDate(cur.getDate() + 1);
//         }

//         if (currentCluster.length > 0) {
//             while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
//                 currentCluster.pop();
//             }
//             if (currentCluster.length > 0) clusters.push(currentCluster);
//         }

//         for (const cluster of clusters) {
//             let hasNewReq = false;
//             const clusterLeavesMap = {};

//             cluster.forEach(item => {
//                 if (item.type === "SICK") {
//                     item.leaves.forEach(l => {
//                         const key = l.isNew ? "NEW_DRAFT" : (l.id || l.leave_id || `${l.fromdate}_${l.todate}`);
//                         clusterLeavesMap[key] = l;
//                         if (l.isNew) hasNewReq = true;
//                     });
//                 }
//             });

//             if (hasNewReq) {
//                 let totalSickDays = 0;
//                 const prevRequests = [];

//                 Object.values(clusterLeavesMap).forEach(l => {
//                     if (l.isNew) {
//                         totalSickDays += parseFloat(currentDeduction) || 0;
//                     } else {
//                         const days = parseFloat(l.total);
//                         if (!isNaN(days) && days > 0) {
//                             totalSickDays += days;
//                         } else {
//                             let dCount = 0;
//                             let curD = new Date(l.fromdate);
//                             const endD = new Date(l.todate);
//                             while (curD <= endD) {
//                                 if (isWorkDay(curD)) dCount++;
//                                 curD.setDate(curD.getDate() + 1);
//                             }
//                             totalSickDays += dCount;
//                         }
//                         prevRequests.push(l);
//                     }
//                 });

//                 if (totalSickDays > 2) {
//                     return {
//                         totalSickDays: totalSickDays,
//                         prevRequests: prevRequests,
//                         newStart,
//                         newEnd
//                     };
//                 }
//             }
//         }

//         return null;
//     }, []);



//     const calendarEvents = [];

//     const calendarCutoffDate = new Date("2026-03-10");

//     leaveHistory.forEach((leave) => {

//         const postingDate = new Date(leave.PostingDate);

//         if (postingDate < calendarCutoffDate) return;

//         let color = "#9ca3af";

//         if (String(leave.Status) === "1") color = "#22c55e";
//         if (String(leave.Status) === "0") color = "#facc15";
//         if (String(leave.Status) === "2") color = "#ef4444";

//         const typeLetter =
//             leave.leavetype === "Earned Leave" ? "E" : "S";

//         const start = new Date(leave.fromdate);
//         const end = new Date(leave.todate);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: typeLetter,
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }

//     });

//     wfhHistory.forEach((wfh) => {

//         let color = "#3b82f6";; // orange for WFH

//         const start = new Date(wfh.start);
//         const end = new Date(wfh.end);

//         let current = new Date(start);

//         while (current <= end) {

//             if (isWorkDay(current)) {   // 👈 ADD THIS LINE
//                 calendarEvents.push({
//                     title: "W",
//                     start: current.toISOString().split("T")[0],
//                     allDay: true,
//                     extendedProps: {
//                         color: color
//                     }
//                 });
//             }

//             current.setDate(current.getDate() + 1);
//         }
//     }
//     );


//     useEffect(() => {
//         const observer = new MutationObserver(() => {
//             setCalendarKey(prev => prev + 1);
//         });

//         observer.observe(document.body, {
//             attributes: true,
//             attributeFilter: ["class"]
//         });

//         return () => observer.disconnect();
//     }, []);
//     useEffect(() => {
//         const timer = setTimeout(() => {

//             if (calendarRef.current) {
//                 const calendarApi = calendarRef.current.getApi();

//                 calendarApi.updateSize();

//                 // force browser layout recalculation
//                 window.dispatchEvent(new Event("resize"));
//             }

//         }, 150);

//         return () => clearTimeout(timer);

//     }, [calendarKey]);

//     const RULE_START_DATE = new Date('2026-01-15');

//     // Helper to check if backdated
//     const isBackdated = (dateStr) => {
//         if (!dateStr) return false;
//         const sDate = new Date(dateStr);
//         const today = new Date();
//         today.setHours(0, 0, 0, 0);
//         return sDate < today;
//     };

//     // --- MANAGER ROUTING ---
//     useEffect(() => {
//         const fetchManager = async () => {
//             if (userData?.dept) {
//                 try {
//                     const response = await fetch(
//                         `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
//                         {
//                             credentials: "include"
//                         }
//                     );

//                     const data = await response.json();

//                     if (data.success) {
//                         setAssignedManagerId(data.managerEmpId);
//                     }

//                 } catch (err) {
//                     console.error("Manager routing failed", err);
//                 }
//             }
//         };

//         fetchManager();

//     }, [userData?.dept]);
//     // --- PROBATION CALCULATION ---
//     const isLeaveInProbation = useCallback((startDate) => {
//         // Only use the new probation_status column (probation ends only after feedback email is sent)
//         if (userData?.probation_status) {
//             return userData.probation_status !== 'Permanent';
//         }

//         if (!userData?.joiningDate || !startDate) return false;
//         const joinDate = new Date(userData.joiningDate);
//         const probationEndDate = new Date(joinDate);
//         probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//         return new Date(startDate) < probationEndDate;
//     }, [userData?.joiningDate, userData?.probation_status]);

//     useEffect(() => {
//         if (userData?.probation_status) {
//             setIsProbation(userData.probation_status !== 'Permanent');
//         } else if (userData?.joiningDate) {
//             const joinDate = new Date(userData.joiningDate);
//             const probationEndDate = new Date(joinDate);
//             probationEndDate.setMonth(probationEndDate.getMonth() + 6);
//             const today = new Date();
//             setIsProbation(today < probationEndDate);
//         }
//     }, [userData?.joiningDate, userData?.probation_status]);


//     const fetchHistory = useCallback(async () => {
//         if (!employeeId) return;

//         try {
//             const response = await fetch(
//                 `/gt-api/get_leaves.php?empid=${employeeId}`,
//                 {
//                     credentials: "include"
//                 }
//             );

//             const data = await response.json();

//             if (data.success) {

//                 const rawLeaves = data.leaves || [];
//                 const allLeaves = recalculateSickLeavePolicy(rawLeaves);

//                 // Full history
//                 setLeaveHistory(allLeaves);

//                 // Filter only for Application Log
//                 const cutoffDate = new Date("2026-03-10");

//                 const filteredLogs = allLeaves.filter(leave => {
//                     const leaveDate = new Date(leave.PostingDate);
//                     return leaveDate >= cutoffDate;
//                 });

//                 setDisplayLogs(filteredLogs);

//                 setDbEarnedCount(parseFloat(data.earned) || 0);
//             }

//         } catch (e) {
//             console.error("Fetch history failed");
//         }

//     }, [employeeId, recalculateSickLeavePolicy]);

//     useEffect(() => {
//         fetchHistory();
//     }, [fetchHistory]);

//     const getTimerData = (todate) => {
//         const end = new Date(todate);
//         end.setHours(0, 0, 0, 0);
//         const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
//         const now = new Date();
//         const diff = deadline - now;
//         if (diff <= 0) return { expired: true, text: "EXPIRED" };
//         const hours = Math.floor(diff / (1000 * 60 * 60));
//         const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//         return { expired: false, text: `${hours}h ${mins}m left` };
//     };



//     // --- UPDATED LEAVE BALANCE CALCULATION ---
//     useEffect(() => {
//         const today = new Date();
//         const currentYear = today.getFullYear();
//         const fiscalYearStart = new Date(currentYear, 3, 1);
//         const activeFiscalYearStart = today < fiscalYearStart
//             ? new Date(currentYear - 1, 3, 1)
//             : fiscalYearStart;

//         // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
//         let calculatedSickTotal = 12;

//         if (userData?.joiningDate) {
//             const joiningDate = new Date(userData.joiningDate);

//             // Financial year end (31 March)
//             const fyEnd = new Date(activeFiscalYearStart);
//             fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
//             fyEnd.setDate(31);
//             fyEnd.setMonth(2); // March

//             // If employee joined within current financial year
//             if (joiningDate > activeFiscalYearStart) {

//                 // If joined after FY end (future case safeguard)
//                 if (joiningDate > fyEnd) {
//                     calculatedSickTotal = 0;
//                 } else {
//                     const joinMonth = joiningDate.getMonth();
//                     const fyEndMonth = 2; // March (0-based index)

//                     // Months remaining including joining month
//                     let monthsRemaining;
//                     if (joinMonth <= fyEndMonth) {
//                         monthsRemaining = fyEndMonth - joinMonth + 1;
//                     } else {
//                         monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
//                     }

//                     // 12 sick leaves per 12 months → 1 per month
//                     calculatedSickTotal = monthsRemaining;
//                 }
//             }
//         }
//         // ===== END OF NEW LOGIC =====

//         let sickUsed = 0;
//         let earnedUsed = 0;

//         leaveHistory.forEach(leave => {
//             const status = String(leave.Status);
//             const days = parseFloat(leave.total) || 0;
//             const leaveDate = new Date(leave.fromdate);
//             const medStatus = String(leave.medical_doc_status);

//             if (status === '0' || status === '1') {
//                 if (leave.leavetype === 'Sick Leave') {
//                     if (leaveDate >= activeFiscalYearStart) sickUsed += days;
//                 }
//                 else if (leave.leavetype === 'Earned Leave') {
//                     if (medStatus === '1') {
//                         // ONLY approved medical = sick
//                         sickUsed += days;
//                     } else {
//                         // pending OR rejected = earned
//                         earnedUsed += days;
//                     }
//                 }
//             }
//         });

//         setLeaveBalances({
//             sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
//             earned: { used: earnedUsed, total: dbEarnedCount }
//         });

//     }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

//     const handleFileUpload = async (e, leaveId) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const formData = new FormData();
//         formData.append('medical_doc', file);
//         formData.append('leave_id', leaveId);
//         formData.append('empid', employeeId);

//         try {
//             setIsSubmitting(true);

//             const response = await fetch(
//                 "/gt-api/upload_medical.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     body: formData
//                 }
//             );

//             const result = await response.json();

//             if (result.success) {
//                 setModal({
//                     show: true,
//                     title: 'SUCCESS',
//                     message: 'File uploaded! Waiting for Admin verification.',
//                     type: 'success'
//                 });

//                 fetchHistory();
//             }

//         } catch (err) {
//             setModal({
//                 show: true,
//                 title: 'ERROR',
//                 message: 'Upload failed.',
//                 type: 'error'
//             });

//         } finally {
//             setIsSubmitting(false);
//         }
//     };
   


//     // --- DEDUCTION & PENALTY LOGIC ---
//     useEffect(() => {
//         if (leaveForm.start && leaveForm.end) {
//             const s = new Date(leaveForm.start);
//             const e = new Date(leaveForm.end);
//             if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

//             let validWorkDays = 0;
//             let tempDate = new Date(s);
//             while (tempDate <= e) {
//                 if (isWorkDay(tempDate)) {
//                     validWorkDays++;
//                 }
//                 tempDate.setDate(tempDate.getDate() + 1);
//             }

//             let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
//             let finalDeduction = baseDays;
//             let msg = "";

//             const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);

//             if (isThisLeaveInProbation && baseDays > 0) {
//                 // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
//                 let penalty = baseDays > 2 ? 2 : 1;
//                 finalDeduction = baseDays + penalty;
//                 msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
//             }

//             setDeduction(finalDeduction);
//             setPenaltyMsg(msg);
//         }
//     }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isLeaveInProbation]);


//     const submitToDB = async (finalType) => {
//         setIsSubmitting(true);
//         const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
//         const formData = new FormData();
//         formData.append('EmailId', userData?.email);
//         formData.append('Department', userData?.dept || "General");
//         formData.append('leavetype', finalType);
//         formData.append('todate', leaveForm.end);
//         formData.append('fromdate', leaveForm.start);
//         formData.append('total', deduction);
//         formData.append('description', leaveForm.reason);
//         formData.append('empid', employeeId);
//         formData.append('isprobation', isThisLeaveInProbation ? 1 : 0);

//         if (medicalFile) {
//             formData.append('medical_doc', medicalFile);
//             formData.append('proof', medicalFile);
//         }

//         if (assignedManagerId) formData.append('manager_id', assignedManagerId);
//         if (editingId) formData.append('id', editingId);

//         try {

//             const response = await fetch("/gt-api/apply_leave.php", {
//                 method: "POST",
//                 credentials: "include",
//                 body: formData
//             });

//             // const result = await response.json();
//             const text = await response.text();
//             console.log("SERVER RESPONSE:", text);

//             const result = JSON.parse(text);

//             if (result.success) {
//                 setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
//                 setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
//                 setMedicalFile(null);
//                 setEditingId(null);
//                 setIsHalfDay(null);
//                 setPenaltyMsg("");
//                 fetchHistory();
//             }
//         } catch (error) {
//             setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
//         } finally { setIsSubmitting(false); }
//     };





//     const handleLeaveSubmit = async (e) => {
//         e.preventDefault();

//         // --- STEP 1: Half-Day Check ---
//         if (leaveForm.start === leaveForm.end && isHalfDay === null) {
//             setModal({
//                 show: true,
//                 title: 'HALF_DAY_QUERY',
//                 message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
//                 type: 'query',
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });
//             return;
//         }

//         const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
//         const currentSickUsed = leaveBalances.sick.used;
//         const potentialTotal = currentSickUsed + deduction;

//         // Only enforce sick quota limit for standard sick leave (deduction <= 2)
//         if (leaveForm.type === 'Sick Leave' && deduction <= 2 && potentialTotal > 12) {
//             setModal({
//                 show: true,
//                 title: 'QUOTA EXCEEDED',
//                 message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
//                 type: 'error'
//             });
//             return; // Stops the submission entirely
//         }

//         // --- STEP 2: Probation Intercept (FIXED MATH) ---
//         if (isThisLeaveInProbation) {
//             // 1. Calculate actual work days manually to ensure accuracy
//             let actualDays = 0;
//             if (isHalfDay) {
//                 actualDays = 0.5;
//             } else {
//                 const s = new Date(leaveForm.start);
//                 const eDate = new Date(leaveForm.end);
//                 let tempDate = new Date(s);
//                 while (tempDate <= eDate) {
//                     if (isWorkDay(tempDate)) actualDays++;
//                     tempDate.setDate(tempDate.getDate() + 1);
//                 }
//             }

//             // 2. Determine penalty based on your rule
//             const penalty = actualDays > 2 ? 2 : 1;

//             setModal({
//                 show: true,
//                 title: 'PROBATION LEAVE POLICY',
//                 message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
//                 type: 'query',
//                 action: (choice) => {
//                     if (choice) {
//                         setModal({ show: false });
//                         submitToDB('Earned Leave');
//                     } else {
//                         setModal({ show: false });
//                     }
//                 }
//             });
//             return;
//         }

//         // --- STEP 3: Your Original Logic (Unchanged) ---
//         const isSingleSickOverTwo = (leaveForm.type === 'Sick Leave' && deduction > 2);
//         let finalLeaveType = isSingleSickOverTwo ? 'Earned Leave' : leaveForm.type;
//         const sDateStr = leaveForm.start;
//         const isBackdatedReq = isBackdated(sDateStr);

//         const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
//         const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
//         if (!isThisLeaveInProbation && deduction > currentBalance) {
//             setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
//             return;
//         }

//         if (leaveForm.type === 'Sick Leave') {
//             const continuousInfo = checkContinuousSickLeaveNotice(leaveForm.start, leaveForm.end, deduction, leaveHistory);

//             if (continuousInfo) {
//                 let modalMessage = "";
//                 if (continuousInfo.prevRequests && continuousInfo.prevRequests.length > 0) {
//                     const prevStr = continuousInfo.prevRequests.map(p => `${p.fromdate} to ${p.todate}`).join(", ");
//                     modalMessage = `Your previous leave request was from ${prevStr}. If this request (${leaveForm.start} to ${leaveForm.end}) is approved, your continuous leave period will total ${continuousInfo.totalSickDays} Sick Leave day(s), which will be converted as Earned Leave with a total deduction of ${continuousInfo.totalSickDays} day(s). Do you want to proceed?`;
//                 } else if (isBackdatedReq) {
//                     if (!medicalFile) {
//                         modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
//                     } else {
//                         modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
//                     }
//                 } else {
//                     modalMessage = `You have applied for ${deduction} Days. Policy says continuous Sick leave of more than 2 days (Total: ${continuousInfo.totalSickDays} day(s)) will automatically be converted as Earned Leave once approved. Do you want to Proceed?`;
//                 }

//                 setModal({
//                     show: true,
//                     title: 'CONTINUOUS SICK LEAVE NOTICE',
//                     message: modalMessage,
//                     type: 'query',
//                     action: (choice) => {
//                         if (choice) {
//                             setModal({ show: false });
//                             // For a single standalone request > 2 days, submit directly as Earned Leave
//                             // For separate consecutive requests <= 2 days, submit as Sick Leave (converted only post-approval)
//                             if (deduction > 2) {
//                                 submitToDB('Earned Leave');
//                             } else {
//                                 submitToDB('Sick Leave');
//                             }
//                         } else {
//                             setModal({ show: false });
//                         }
//                     }
//                 });
//                 return;
//             }
//         }

//         submitToDB(finalLeaveType);
//     };




//     const handleModifyLeave = (log) => {
//         setEditingId(log.id);
//         setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
//         setIsHalfDay(null);
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//     };

//     const handleDeleteLeave = (id) => {
//         setModal({
//             show: true,
//             title: 'CONFIRM_DELETE',
//             message: 'Remove this request?',
//             type: 'query',
//             action: async (choice) => {
//                 if (choice) {
//                     try {
//                         await fetch(
//                             `/gt-api/delete_leave.php?id=${id}`,
//                             {
//                                 method: 'GET',
//                                 credentials: 'include'
//                             }
//                         );

//                         fetchHistory();
//                         setModal({ show: false });

//                     } catch (err) {
//                         setModal({
//                             show: true,
//                             title: 'ERROR',
//                             message: 'Failed.',
//                             type: 'error'
//                         });
//                     }
//                 } else {
//                     setModal({ show: false });
//                 }
//             }
//         });
//     };




//     return (
//         <div className="attendance-module">
//             {modal.show && (
//                 <div className="cyber-modal-overlay">
//                     <div className={`cyber-modal-card ${modal.type}`}>
//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>
//                         <div className="modal-actions">
//                             {modal.type === 'query' ? (
//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>
//                             ) : (
//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             )}


//             <div className="wfh-top-container">
//                 <button
//                     className="wfh-top-btn"
//                     onClick={() => navigate('/work-from-home')}
//                 >
//                     🚨 Emergency WFH Request
//                 </button>
//             </div>

//             {/* <div className="leave-stats-grid">
//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
//                             <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
//                             <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
//                             <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
//                         </div>
//                     );
//                 })}



//             </div> */}

//             <div className="leave-stats-grid">

//                 {['sick', 'earned'].map(key => {
//                     const remaining = leaveBalances[key].total - leaveBalances[key].used;
//                     return (
//                         <div
//                             key={key}
//                             className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
//                             style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
//                         >
//                             <span className="stat-label">
//                                 {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
//                             </span>

//                             <h1 className="big-stat-text">
//                                 {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
//                             </h1>

//                             <div className="stat-footer">
//                                 Used: {leaveBalances[key].used} / {leaveBalances[key].total}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* CALENDAR CARD */}
//                 <div className="stat-highlight glass calendar-card">
//                     <FullCalendar
//                         ref={calendarRef}
//                         key={calendarKey}
//                         plugins={[dayGridPlugin, interactionPlugin]}
//                         initialView="dayGridMonth"
//                         events={calendarEvents}
//                         height="auto"
//                         expandRows={true}
//                         fixedWeekCount={false}
//                         headerToolbar={{
//                             left: "prev,next",
//                             center: "title",
//                             right: "today"
//                         }}
//                         eventContent={(info) => {

//                             const color = info.event.extendedProps.color;

//                             return (
//                                 <div className="leave-circle" style={{ backgroundColor: color }}>
//                                     {info.event.title}
//                                 </div>
//                             );
//                         }}
//                     />

//                     <div className="calendar-legend">
//                         <span className="legend approved"></span> Approved
//                         <span className="legend pending"></span> Pending
//                         <span className="legend rejected"></span> Rejected
//                         <span className="legend wfh"></span> WFH
//                     </div>
//                 </div>

//             </div>








//             <div className="attendance-layout">

//                 <div className="panel glass">
//                     <div className="panel-header">
//                         <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
//                         <span className="deduction-badge">{deduction} Units</span>
//                     </div>
//                     <form onSubmit={handleLeaveSubmit}>
//                         <div className="input-group">
//                             <label>CATEGORY</label>
//                             <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
//                                 <option value="Sick Leave">Sick Leave</option>
//                                 <option value="Earned Leave">Earned Leave</option>
//                             </select>
//                         </div>
//                         {/* <div className="input-row">
//                             <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
//                             <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
//                         </div> */}

//                         <div className="input-row">
//                             <div className="input-group">
//                                 <label>START</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={startRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={leaveForm.start}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (startRef.current?.showPicker) {
//                                                 startRef.current.showPicker();
//                                             } else {
//                                                 startRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>

//                             <div className="input-group">
//                                 <label>END</label>

//                                 <div className="date-input-wrapper">
//                                     <input
//                                         ref={endRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={leaveForm.start}
//                                         value={leaveForm.end}
//                                         onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
//                                     />

//                                     <span
//                                         className="calendar-glow-icon"
//                                         onClick={() => {
//                                             if (endRef.current?.showPicker) {
//                                                 endRef.current.showPicker();
//                                             } else {
//                                                 endRef.current.focus();
//                                             }
//                                         }}
//                                     >
//                                         📅
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>


//                         {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isLeaveInProbation(leaveForm.start)) && (
//                             <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
//                                 <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
//                                 <input
//                                     type="file"
//                                     className="cyber-input"
//                                     onChange={(e) => setMedicalFile(e.target.files[0])}
//                                     accept=".pdf,.jpg,.png,.jpeg"
//                                 />
//                                 <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
//                             </div>
//                         )}

//                         <div className="input-group"><label>REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
//                         {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
//                     </form>
//                 </div>



//                 <div className="panel glass">
//                     <h3 className="panel-title">Application Log</h3>
//                     <div className="table-scroll">
//                         <table className="history-table">
//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>TYPE</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>UNIT</th>
//                                     <th>STATUS</th>
//                                     <th>DOCUMENTATION</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/* {leaveHistory.map((log, i) => { */}
//                                 {displayLogs.map((log, i) => {
//                                     const isApproved = String(log.Status) === '1';
//                                     const isPending = String(log.Status) === '0';
//                                     const isOver = new Date() > new Date(log.todate);
//                                     const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
//                                     const timer = getTimerData(log.todate);
//                                     const medStatus = String(log.medical_doc_status);

//                                     // 1. TYPE LOGIC: Show only "Sick" or "Earned"
//                                     const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
//                                         ? 'Sick'
//                                         : log.leavetype.replace(' Leave', '');

//                                     // 2. DATE LOGIC: Show as "29/1"
//                                     const formatShortDate = (dateStr) => {
//                                         const d = new Date(dateStr);
//                                         if (isNaN(d)) return "-";
//                                         return `${d.getDate()}/${d.getMonth() + 1}`;
//                                     };

//                                     return (
//                                         <tr key={log.id || i}>
//                                             <td>{String(i + 1).padStart(2, '')}</td>

//                                             {/* Simplified Type: Sick or Earned */}
//                                             <td style={{ fontWeight: '500' }}>{displayType}</td>

//                                             {/* Date/Month only */}
//                                             <td>{formatShortDate(log.fromdate)}</td>
//                                             <td>{formatShortDate(log.todate)}</td>

//                                             {/* Unit only (e.g., 3, 0.5) */}
//                                             <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
//                                                     {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
//                                                         <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
//                                                     </div>
//                                                 )}

//                                                 {isApproved &&
//                                                     log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
//                                                     parseFloat(log.total) > 2 &&          // ✅ only >2 days
//                                                     isOver &&
//                                                     !hasFile &&
//                                                     !timer.expired &&
//                                                     !isProbation && (
//                                                         <div className="upload-cell">
//                                                             <span className="countdown-timer">⏳ {timer.text}</span>
//                                                             <label className="action-upload">
//                                                                 Upload
//                                                                 <input
//                                                                     type="file"
//                                                                     hidden
//                                                                     onChange={(e) => handleFileUpload(e, log.id)}
//                                                                     accept=".pdf,.jpg,.png"
//                                                                 />
//                                                             </label>
//                                                         </div>
//                                                     )}
//                                                 {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
//                                                 {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
//                                                 {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
//                                                 {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
//                                                 {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default Attendance;






































import React, { useState, useEffect, useCallback, useRef } from "react";
// import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import '../styles/Attendance.css';

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

const Attendance = ({ employeeId, userData }) => {
    const navigate = useNavigate();
    // --- 1. STATE MANAGEMENT ---
    const [leaveBalances, setLeaveBalances] = useState({
        sick: { used: 0, total: 12 },
        earned: { used: 0, total: 0 }
    });

    const [calendarKey, setCalendarKey] = useState(0);
    const calendarRef = useRef(null);
    const [dbEarnedCount, setDbEarnedCount] = useState(0);
    const [isProbation, setIsProbation] = useState(false);
    const [isHalfDay, setIsHalfDay] = useState(null);
    const [modal, setModal] = useState({ show: false, title: '', message: '', type: '', action: null });
    const [leaveHistory, setLeaveHistory] = useState([]);
    const [wfhHistory, setWfhHistory] = useState([]);
    const [displayLogs, setDisplayLogs] = useState([]);
    const [deduction, setDeduction] = useState(0);
    const [penaltyMsg, setPenaltyMsg] = useState("");
    const [leaveForm, setLeaveForm] = useState({ type: 'Sick Leave', start: '', end: '', reason: '' });

    const [medicalFile, setMedicalFile] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [assignedManagerId, setAssignedManagerId] = useState(null);


    const startRef = useRef(null);
    const endRef = useRef(null);



    const fetchWFH = useCallback(async () => {

        if (!employeeId) return;

        try {

            const res = await fetch(
                `/gt-api/get_wfh.php?empid=${employeeId}`,
                { credentials: "include" }
            );

            const data = await res.json();

            if (data.success) {
                setWfhHistory(data.requests || []);
            }

        } catch (err) {
            console.error("WFH fetch failed");
        }

    }, [employeeId]);

    useEffect(() => {
        fetchWFH();
    }, [fetchWFH]);

    const PUBLIC_HOLIDAYS = [
        '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
        '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
    ];

    const isWorkDay = (date) => {
        const day = date.getDay();
        const dateString = date.toISOString().split('T')[0];
        const isWeekend = (day === 0 || day === 6);
        const isHoliday = PUBLIC_HOLIDAYS.includes(dateString);
        return !isWeekend && !isHoliday;
    };

    const POLICY_EFFECTIVE_DATE = "2026-08-26";

    // --- RECALCULATE SICK LEAVE CONTINUOUS POLICY (CLIENT HELPER) ---
    const recalculateSickLeavePolicy = useCallback((leaves) => {
        if (!leaves || !Array.isArray(leaves)) return leaves || [];

        const updatedLeaves = leaves.map(l => ({ ...l }));
        const approvedLeaves = updatedLeaves.filter(l => String(l.Status) === "1");

        const sickDateMap = {};
        const approvedSickLeavesMap = {};

        approvedLeaves.forEach(l => {
            const lId = l.id || l.leave_id;
            const lType = (l.leavetype || l.LeaveType || "").trim();
            const lRemark = l.AdminRemark || l.description || "";
            const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
            const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));

            if (isSick && l.fromdate && l.todate) {
                approvedSickLeavesMap[lId] = { leave: l, isConverted };
                let cur = new Date(l.fromdate);
                const end = new Date(l.todate);

                while (cur <= end) {
                    const dStr = cur.toISOString().split("T")[0];
                    if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
                    sickDateMap[dStr].push(lId);
                    cur.setDate(cur.getDate() + 1);
                }
            }
        });

        const sortedDates = Object.keys(sickDateMap).sort();
        if (sortedDates.length === 0) return updatedLeaves;

        const minDate = new Date(sortedDates[0]);
        const maxDate = new Date(sortedDates[sortedDates.length - 1]);

        const clusters = [];
        let currentCluster = [];

        let cur = new Date(minDate);
        while (cur <= maxDate) {
            const dStr = cur.toISOString().split("T")[0];
            const hasSick = Boolean(sickDateMap[dStr]);
            const workday = isWorkDay(cur);

            if (hasSick) {
                currentCluster.push({ date: dStr, type: "SICK", leaveIds: sickDateMap[dStr] });
            } else if (!workday) {
                if (currentCluster.length > 0) {
                    currentCluster.push({ date: dStr, type: "BRIDGE", leaveIds: [] });
                }
            } else {
                if (currentCluster.length > 0) {
                    while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
                        currentCluster.pop();
                    }
                    if (currentCluster.length > 0) clusters.push(currentCluster);
                    currentCluster = [];
                }
            }
            cur.setDate(cur.getDate() + 1);
        }

        if (currentCluster.length > 0) {
            while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
                currentCluster.pop();
            }
            if (currentCluster.length > 0) clusters.push(currentCluster);
        }

        clusters.forEach(cluster => {
            const clusterLeavesMap = {};

            cluster.forEach(item => {
                if (item.type === "SICK") {
                    item.leaveIds.forEach(id => {
                        const lObj = approvedSickLeavesMap[id];
                        if (lObj) clusterLeavesMap[id] = lObj.leave;
                    });
                }
            });

            let totalSickDays = 0;
            Object.values(clusterLeavesMap).forEach(l => {
                const days = parseFloat(l.total);
                if (!isNaN(days) && days > 0) {
                    totalSickDays += days;
                } else {
                    let dCount = 0;
                    let curD = new Date(l.fromdate);
                    const endD = new Date(l.todate);
                    while (curD <= endD) {
                        if (isWorkDay(curD)) dCount++;
                        curD.setDate(curD.getDate() + 1);
                    }
                    totalSickDays += dCount;
                }
            });

            const shouldConvert = totalSickDays > 2;

            Object.keys(clusterLeavesMap).forEach(id => {
                const targetLeave = updatedLeaves.find(l => String(l.id || l.leave_id) === String(id));
                if (targetLeave) {
                    const isEligibleForPolicy = targetLeave.fromdate && targetLeave.fromdate >= POLICY_EFFECTIVE_DATE;
                    if (shouldConvert && isEligibleForPolicy) {
                        targetLeave.leavetype = "Earned Leave";
                    } else if (approvedSickLeavesMap[id]?.isConverted) {
                        targetLeave.leavetype = "Sick Leave";
                    }
                }
            });
        });

        return updatedLeaves;
    }, []);

    // --- HELPER TO CHECK CONTINUOUS SICK LEAVE NOTICE FOR NEW REQUEST ---
    const checkContinuousSickLeaveNotice = useCallback((newStart, newEnd, currentDeduction, leavesHistory) => {
        if (!newStart || !newEnd) return null;
        if (newStart < POLICY_EFFECTIVE_DATE) return null;

        const existingSickLeaves = (leavesHistory || []).filter(l => {
            const status = String(l.Status);
            const lType = (l.leavetype || l.LeaveType || "").trim();
            const lRemark = l.AdminRemark || l.description || "";
            const isConverted = lRemark.includes("[CONVERTED_TO_EARNED]");
            const isSick = (lType === "Sick Leave" || (lType === "Earned Leave" && isConverted));
            const isEligible = l.fromdate && l.fromdate >= POLICY_EFFECTIVE_DATE;
            return isSick && isEligible && (status === "1" || status === "0" || status === "null");
        });

        const newReq = {
            id: "NEW_DRAFT_REQ",
            fromdate: newStart,
            todate: newEnd,
            leavetype: "Sick Leave",
            Status: "1",
            total: currentDeduction,
            isNew: true
        };

        const allLeavesToTest = [...existingSickLeaves, newReq];

        const sickDateMap = {};
        allLeavesToTest.forEach(l => {
            let cur = new Date(l.fromdate);
            const end = new Date(l.todate);
            while (cur <= end) {
                const dStr = cur.toISOString().split("T")[0];
                if (!sickDateMap[dStr]) sickDateMap[dStr] = [];
                sickDateMap[dStr].push(l);
                cur.setDate(cur.getDate() + 1);
            }
        });

        const sortedDates = Object.keys(sickDateMap).sort();
        if (sortedDates.length === 0) return null;

        const minDate = new Date(sortedDates[0]);
        const maxDate = new Date(sortedDates[sortedDates.length - 1]);

        const clusters = [];
        let currentCluster = [];

        let cur = new Date(minDate);
        while (cur <= maxDate) {
            const dStr = cur.toISOString().split("T")[0];
            const hasSick = Boolean(sickDateMap[dStr]);
            const workday = isWorkDay(cur);

            if (hasSick) {
                currentCluster.push({ date: dStr, type: "SICK", leaves: sickDateMap[dStr] });
            } else if (!workday) {
                if (currentCluster.length > 0) {
                    currentCluster.push({ date: dStr, type: "BRIDGE", leaves: [] });
                }
            } else {
                if (currentCluster.length > 0) {
                    while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
                        currentCluster.pop();
                    }
                    if (currentCluster.length > 0) clusters.push(currentCluster);
                    currentCluster = [];
                }
            }
            cur.setDate(cur.getDate() + 1);
        }

        if (currentCluster.length > 0) {
            while (currentCluster.length > 0 && currentCluster[currentCluster.length - 1].type === "BRIDGE") {
                currentCluster.pop();
            }
            if (currentCluster.length > 0) clusters.push(currentCluster);
        }

        for (const cluster of clusters) {
            let hasNewReq = false;
            const clusterLeavesMap = {};

            cluster.forEach(item => {
                if (item.type === "SICK") {
                    item.leaves.forEach(l => {
                        const key = l.isNew ? "NEW_DRAFT" : (l.id || l.leave_id || `${l.fromdate}_${l.todate}`);
                        clusterLeavesMap[key] = l;
                        if (l.isNew) hasNewReq = true;
                    });
                }
            });

            if (hasNewReq) {
                let totalSickDays = 0;
                const prevRequests = [];

                Object.values(clusterLeavesMap).forEach(l => {
                    if (l.isNew) {
                        totalSickDays += parseFloat(currentDeduction) || 0;
                    } else {
                        const days = parseFloat(l.total);
                        if (!isNaN(days) && days > 0) {
                            totalSickDays += days;
                        } else {
                            let dCount = 0;
                            let curD = new Date(l.fromdate);
                            const endD = new Date(l.todate);
                            while (curD <= endD) {
                                if (isWorkDay(curD)) dCount++;
                                curD.setDate(curD.getDate() + 1);
                            }
                            totalSickDays += dCount;
                        }
                        prevRequests.push(l);
                    }
                });

                if (totalSickDays > 2) {
                    return {
                        totalSickDays: totalSickDays,
                        prevRequests: prevRequests,
                        newStart,
                        newEnd
                    };
                }
            }
        }

        return null;
    }, []);



    const calendarEvents = [];

    const calendarCutoffDate = new Date("2026-03-10");

    leaveHistory.forEach((leave) => {

        const postingDate = new Date(leave.PostingDate);

        if (postingDate < calendarCutoffDate) return;

        let color = "#9ca3af";

        if (String(leave.Status) === "1") color = "#22c55e";
        if (String(leave.Status) === "0") color = "#facc15";
        if (String(leave.Status) === "2") color = "#ef4444";

        const typeLetter =
            leave.leavetype === "Earned Leave" ? "E" : "S";

        const start = new Date(leave.fromdate);
        const end = new Date(leave.todate);

        let current = new Date(start);

        while (current <= end) {

            if (isWorkDay(current)) {   // 👈 ADD THIS LINE
                calendarEvents.push({
                    title: typeLetter,
                    start: current.toISOString().split("T")[0],
                    allDay: true,
                    extendedProps: {
                        color: color
                    }
                });
            }

            current.setDate(current.getDate() + 1);
        }

    });

    wfhHistory.forEach((wfh) => {

        let color = "#3b82f6";; // orange for WFH

        const start = new Date(wfh.start);
        const end = new Date(wfh.end);

        let current = new Date(start);

        while (current <= end) {

            if (isWorkDay(current)) {   // 👈 ADD THIS LINE
                calendarEvents.push({
                    title: "W",
                    start: current.toISOString().split("T")[0],
                    allDay: true,
                    extendedProps: {
                        color: color
                    }
                });
            }

            current.setDate(current.getDate() + 1);
        }
    }
    );


    useEffect(() => {
        const observer = new MutationObserver(() => {
            setCalendarKey(prev => prev + 1);
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"]
        });

        return () => observer.disconnect();
    }, []);
    useEffect(() => {
        const timer = setTimeout(() => {

            if (calendarRef.current) {
                const calendarApi = calendarRef.current.getApi();

                calendarApi.updateSize();

                // force browser layout recalculation
                window.dispatchEvent(new Event("resize"));
            }

        }, 150);

        return () => clearTimeout(timer);

    }, [calendarKey]);

    const RULE_START_DATE = new Date('2026-01-15');

    // Helper to check if backdated
    const isBackdated = (dateStr) => {
        if (!dateStr) return false;
        const sDate = new Date(dateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return sDate < today;
    };

    // --- MANAGER ROUTING ---
    useEffect(() => {
        const fetchManager = async () => {
            if (userData?.dept) {
                try {
                    const response = await fetch(
                        `/gt-api/get_manager_by_dept.php?dept=${userData.dept}`,
                        {
                            credentials: "include"
                        }
                    );

                    const data = await response.json();

                    if (data.success) {
                        setAssignedManagerId(data.managerEmpId);
                    }

                } catch (err) {
                    console.error("Manager routing failed", err);
                }
            }
        };

        fetchManager();

    }, [userData?.dept]);
    // --- PROBATION CALCULATION ---
    const isLeaveInProbation = useCallback((startDate) => {
        // Only use the new probation_status column (probation ends only after feedback email is sent)
        if (userData?.probation_status) {
            return userData.probation_status !== 'Permanent';
        }

        if (!userData?.joiningDate || !startDate) return false;
        const joinDate = new Date(userData.joiningDate);
        const probationEndDate = new Date(joinDate);
        probationEndDate.setMonth(probationEndDate.getMonth() + 6);
        return new Date(startDate) < probationEndDate;
    }, [userData?.joiningDate, userData?.probation_status]);

    useEffect(() => {
        if (userData?.probation_status) {
            setIsProbation(userData.probation_status !== 'Permanent');
        } else if (userData?.joiningDate) {
            const joinDate = new Date(userData.joiningDate);
            const probationEndDate = new Date(joinDate);
            probationEndDate.setMonth(probationEndDate.getMonth() + 6);
            const today = new Date();
            setIsProbation(today < probationEndDate);
        }
    }, [userData?.joiningDate, userData?.probation_status]);


    const fetchHistory = useCallback(async () => {
        if (!employeeId) return;

        try {
            const response = await fetch(
                `/gt-api/get_leaves.php?empid=${employeeId}`,
                {
                    credentials: "include"
                }
            );

            const data = await response.json();

            if (data.success) {

                const rawLeaves = data.leaves || [];
                const allLeaves = recalculateSickLeavePolicy(rawLeaves);

                // Full history
                setLeaveHistory(allLeaves);

                // Filter only for Application Log
                const cutoffDate = new Date("2026-03-10");

                const filteredLogs = allLeaves.filter(leave => {
                    const leaveDate = new Date(leave.PostingDate);
                    return leaveDate >= cutoffDate;
                });

                setDisplayLogs(filteredLogs);

                setDbEarnedCount(parseFloat(data.earned) || 0);
            }

        } catch (e) {
            console.error("Fetch history failed");
        }

    }, [employeeId, recalculateSickLeavePolicy]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    const getTimerData = (todate) => {
        const end = new Date(todate);
        end.setHours(0, 0, 0, 0);
        const deadline = new Date(end.getTime() + (48 * 60 * 60 * 1000));
        const now = new Date();
        const diff = deadline - now;
        if (diff <= 0) return { expired: true, text: "EXPIRED" };
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return { expired: false, text: `${hours}h ${mins}m left` };
    };



    // --- UPDATED LEAVE BALANCE CALCULATION ---
    useEffect(() => {
        const today = new Date();
        const currentYear = today.getFullYear();
        const fiscalYearStart = new Date(currentYear, 3, 1);
        const activeFiscalYearStart = today < fiscalYearStart
            ? new Date(currentYear - 1, 3, 1)
            : fiscalYearStart;

        // ===== NEW SICK TOTAL LOGIC (JOINING DATE BASED) =====
        let calculatedSickTotal = 12;

        if (userData?.joiningDate) {
            const joiningDate = new Date(userData.joiningDate);

            // Financial year end (31 March)
            const fyEnd = new Date(activeFiscalYearStart);
            fyEnd.setFullYear(activeFiscalYearStart.getFullYear() + 1);
            fyEnd.setDate(31);
            fyEnd.setMonth(2); // March

            // If employee joined within current financial year
            if (joiningDate > activeFiscalYearStart) {

                // If joined after FY end (future case safeguard)
                if (joiningDate > fyEnd) {
                    calculatedSickTotal = 0;
                } else {
                    const joinMonth = joiningDate.getMonth();
                    const fyEndMonth = 2; // March (0-based index)

                    // Months remaining including joining month
                    let monthsRemaining;
                    if (joinMonth <= fyEndMonth) {
                        monthsRemaining = fyEndMonth - joinMonth + 1;
                    } else {
                        monthsRemaining = (12 - joinMonth) + (fyEndMonth + 1);
                    }

                    // 12 sick leaves per 12 months → 1 per month
                    calculatedSickTotal = monthsRemaining;
                }
            }
        }
        // ===== END OF NEW LOGIC =====

        let sickUsed = 0;
        let earnedUsed = 0;

        leaveHistory.forEach(leave => {
            const status = String(leave.Status);
            const days = parseFloat(leave.total) || 0;
            const leaveDate = new Date(leave.fromdate);
            const medStatus = String(leave.medical_doc_status);

            if (status === '0' || status === '1') {
                if (leave.leavetype === 'Sick Leave') {
                    if (leaveDate >= activeFiscalYearStart) sickUsed += days;
                }
                else if (leave.leavetype === 'Earned Leave') {
                    if (medStatus === '1') {
                        // ONLY approved medical = sick
                        sickUsed += days;
                    } else {
                        // pending OR rejected = earned
                        earnedUsed += days;
                    }
                }
            }
        });

        setLeaveBalances({
            sick: { used: sickUsed, total: calculatedSickTotal }, // only change here
            earned: { used: earnedUsed, total: dbEarnedCount }
        });

    }, [leaveHistory, dbEarnedCount, userData?.joiningDate]);

    const handleFileUpload = async (e, leaveId) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('medical_doc', file);
        formData.append('leave_id', leaveId);
        formData.append('empid', employeeId);

        try {
            setIsSubmitting(true);

            const response = await fetch(
                "/gt-api/upload_medical.php",
                {
                    method: "POST",
                    credentials: "include",
                    body: formData
                }
            );

            const result = await response.json();

            if (result.success) {
                setModal({
                    show: true,
                    title: 'SUCCESS',
                    message: 'File uploaded! Waiting for Admin verification.',
                    type: 'success'
                });

                fetchHistory();
            }

        } catch (err) {
            setModal({
                show: true,
                title: 'ERROR',
                message: 'Upload failed.',
                type: 'error'
            });

        } finally {
            setIsSubmitting(false);
        }
    };



    // --- DEDUCTION & PENALTY LOGIC ---
    useEffect(() => {
        if (leaveForm.start && leaveForm.end) {
            const s = new Date(leaveForm.start);
            const e = new Date(leaveForm.end);
            if (e < s) { setDeduction(0); setPenaltyMsg(""); return; }

            let validWorkDays = 0;
            let tempDate = new Date(s);
            while (tempDate <= e) {
                if (isWorkDay(tempDate)) {
                    validWorkDays++;
                }
                tempDate.setDate(tempDate.getDate() + 1);
            }

            let baseDays = isHalfDay === true ? 0.5 : validWorkDays;
            let finalDeduction = baseDays;
            let msg = "";

            const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);

            if (isThisLeaveInProbation && baseDays > 0) {
                // Logic: 0.5, 1, 2 days -> +1 | More than 2 -> +2
                let penalty = baseDays > 2 ? 2 : 1;
                finalDeduction = baseDays + penalty;
                msg = `Probation Policy: ${baseDays} day(s) + ${penalty} penalty = ${finalDeduction} Total deduction.`;
            }

            setDeduction(finalDeduction);
            setPenaltyMsg(msg);
        }
    }, [leaveForm.start, leaveForm.end, isHalfDay, modal.show, isLeaveInProbation]);


    const submitToDB = async (finalType) => {
        setIsSubmitting(true);
        const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
        const formData = new FormData();
        formData.append('EmailId', userData?.email);
        formData.append('Department', userData?.dept || "General");
        formData.append('leavetype', finalType);
        formData.append('todate', leaveForm.end);
        formData.append('fromdate', leaveForm.start);
        formData.append('total', deduction);
        formData.append('description', leaveForm.reason);
        formData.append('empid', employeeId);
        formData.append('isprobation', isThisLeaveInProbation ? 1 : 0);

        if (medicalFile) {
            formData.append('medical_doc', medicalFile);
            formData.append('proof', medicalFile);
        }

        if (assignedManagerId) formData.append('manager_id', assignedManagerId);
        if (editingId) formData.append('id', editingId);

        try {

            const response = await fetch("/gt-api/apply_leave.php", {
                method: "POST",
                credentials: "include",
                body: formData
            });

            // const result = await response.json();
            const text = await response.text();
            console.log("SERVER RESPONSE:", text);

            const result = JSON.parse(text);

            if (result.success) {
                setModal({ show: true, title: 'SUCCESS', message: 'Leave submitted successfully!', type: 'success' });
                setLeaveForm({ type: 'Sick Leave', start: '', end: '', reason: '' });
                setMedicalFile(null);
                setEditingId(null);
                setIsHalfDay(null);
                setPenaltyMsg("");
                fetchHistory();
            }
        } catch (error) {
            setModal({ show: true, title: 'SERVER ERROR', message: 'Check Connection.', type: 'error' });
        } finally { setIsSubmitting(false); }
    };





    const handleLeaveSubmit = async (e) => {
        e.preventDefault();

        // --- STEP 1: Half-Day Check ---
        if (leaveForm.start === leaveForm.end && isHalfDay === null) {
            setModal({
                show: true,
                title: 'HALF_DAY_QUERY',
                message: `Is this a Half-Day leave request for ${leaveForm.start}?`,
                type: 'query',
                action: (choice) => {
                    setIsHalfDay(choice);
                    setModal({ show: false });
                }
            });
            return;
        }

        const isThisLeaveInProbation = isLeaveInProbation(leaveForm.start);
        const currentSickUsed = leaveBalances.sick.used;
        const potentialTotal = currentSickUsed + deduction;

        // Only enforce sick quota limit for standard sick leave (deduction <= 2)
        if (leaveForm.type === 'Sick Leave' && deduction <= 2 && potentialTotal > 12) {
            setModal({
                show: true,
                title: 'QUOTA EXCEEDED',
                message: `You have ${12 - currentSickUsed} days left (including pending requests). This request is for ${deduction} days.`,
                type: 'error'
            });
            return; // Stops the submission entirely
        }

        // --- STEP 2: Probation Intercept (FIXED MATH) ---
        if (isThisLeaveInProbation) {
            // 1. Calculate actual work days manually to ensure accuracy
            let actualDays = 0;
            if (isHalfDay) {
                actualDays = 0.5;
            } else {
                const s = new Date(leaveForm.start);
                const eDate = new Date(leaveForm.end);
                let tempDate = new Date(s);
                while (tempDate <= eDate) {
                    if (isWorkDay(tempDate)) actualDays++;
                    tempDate.setDate(tempDate.getDate() + 1);
                }
            }

            // 2. Determine penalty based on your rule
            const penalty = actualDays > 2 ? 2 : 1;

            setModal({
                show: true,
                title: 'PROBATION LEAVE POLICY',
                message: `You are in probation period as per policy your sick leave will be considered as earned leave you applied for ${actualDays} days so it will deduct +${penalty} , your total leaves are ${deduction} days , do you want to proceed?`,
                type: 'query',
                action: (choice) => {
                    if (choice) {
                        setModal({ show: false });
                        submitToDB('Earned Leave');
                    } else {
                        setModal({ show: false });
                    }
                }
            });
            return;
        }

        // --- STEP 3: Your Original Logic (Unchanged) ---
        const isSingleSickOverTwo = (leaveForm.type === 'Sick Leave' && deduction > 2);
        let finalLeaveType = isSingleSickOverTwo ? 'Earned Leave' : leaveForm.type;
        const sDateStr = leaveForm.start;
        const isBackdatedReq = isBackdated(sDateStr);

        const leaveKey = finalLeaveType === 'Sick Leave' ? 'sick' : 'earned';
        const currentBalance = leaveBalances[leaveKey].total - leaveBalances[leaveKey].used;
        if (!isThisLeaveInProbation && deduction > currentBalance) {
            setModal({ show: true, title: 'INSUFFICIENT BALANCE', message: `Requested ${deduction}, balance is ${currentBalance}.`, type: 'error' });
            return;
        }

        if (leaveForm.type === 'Sick Leave') {
            const continuousInfo = checkContinuousSickLeaveNotice(leaveForm.start, leaveForm.end, deduction, leaveHistory);

            if (continuousInfo) {
                let modalMessage = "";
                if (continuousInfo.prevRequests && continuousInfo.prevRequests.length > 0) {
                    const prevStr = continuousInfo.prevRequests.map(p => `${p.fromdate} to ${p.todate}`).join(", ");
                    modalMessage = `Your previous leave request was from ${prevStr}. If this request (${leaveForm.start} to ${leaveForm.end}) is approved, your continuous leave period will total ${continuousInfo.totalSickDays} Sick Leave day(s), which will be converted as Earned Leave with a total deduction of ${continuousInfo.totalSickDays} day(s). Do you want to proceed?`;
                } else if (isBackdatedReq) {
                    if (!medicalFile) {
                        modalMessage = `You haven't uploaded a medical certificate for this backdated leave. so it will be automatically considered as Earned Leave. Do You Want to Proceed?`;
                    } else {
                        modalMessage = `As you are applying as backdated leave for ${deduction} Days and have uploaded a medical certificate, if Document is approved it will be considered sick leave; if not, it remains earned leave. Do you want to Proceed?`;
                    }
                } else {
                    modalMessage = `You have applied for ${deduction} Days. Policy says continuous Sick leave of more than 2 days (Total: ${continuousInfo.totalSickDays} day(s)) will automatically be converted as Earned Leave once approved. Do you want to Proceed?`;
                }

                setModal({
                    show: true,
                    title: 'CONTINUOUS SICK LEAVE NOTICE',
                    message: modalMessage,
                    type: 'query',
                    action: (choice) => {
                        if (choice) {
                            setModal({ show: false });
                            // For a single standalone request > 2 days, submit directly as Earned Leave
                            // For separate consecutive requests <= 2 days, submit as Sick Leave (converted only post-approval)
                            if (deduction > 2) {
                                submitToDB('Earned Leave');
                            } else {
                                submitToDB('Sick Leave');
                            }
                        } else {
                            setModal({ show: false });
                        }
                    }
                });
                return;
            }
        }

        submitToDB(finalLeaveType);
    };




    const handleModifyLeave = (log) => {
        setEditingId(log.id);
        setLeaveForm({ type: log.leavetype, start: log.fromdate, end: log.todate, reason: log.description });
        setIsHalfDay(null);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDeleteLeave = (id) => {
        setModal({
            show: true,
            title: 'CONFIRM_DELETE',
            message: 'Remove this request?',
            type: 'query',
            action: async (choice) => {
                if (choice) {
                    try {
                        await fetch(
                            `/gt-api/delete_leave.php?id=${id}`,
                            {
                                method: 'GET',
                                credentials: 'include'
                            }
                        );

                        fetchHistory();
                        setModal({ show: false });

                    } catch (err) {
                        setModal({
                            show: true,
                            title: 'ERROR',
                            message: 'Failed.',
                            type: 'error'
                        });
                    }
                } else {
                    setModal({ show: false });
                }
            }
        });
    };




    return (
        <div className="attendance-module">
            {modal.show && (
                <div className="cyber-modal-overlay">
                    <div className={`cyber-modal-card ${modal.type}`}>
                        <h3>{modal.title}</h3>
                        <p className="modal-text">{modal.message}</p>
                        <div className="modal-actions">
                            {modal.type === 'query' ? (
                                <>
                                    <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
                                    <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
                                </>
                            ) : (
                                <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>CLOSE</button>
                            )}
                        </div>
                    </div>
                </div>
            )}


            <div className="wfh-top-container">
                <button
                    className="wfh-top-btn"
                    onClick={() => navigate('/work-from-home')}
                >
                    🚨 Emergency WFH Request
                </button>
            </div>

            {/* <div className="leave-stats-grid">
                {['sick', 'earned'].map(key => {
                    const remaining = leaveBalances[key].total - leaveBalances[key].used;
                    return (
                        <div key={key} className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
                            style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}>
                            <span className="stat-label">{key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}</span>
                            <h1 className="big-stat-text">{remaining % 1 === 0 ? remaining : remaining.toFixed(1)}</h1>
                            <div className="stat-footer">Used: {leaveBalances[key].used} / {leaveBalances[key].total}</div>
                        </div>
                    );
                })}



            </div> */}

            <div className="leave-stats-grid">

                {['sick', 'earned'].map(key => {
                    const remaining = leaveBalances[key].total - leaveBalances[key].used;
                    return (
                        <div
                            key={key}
                            className={`stat-highlight glass ${remaining < 0 ? 'negative-balance' : ''}`}
                            style={{ "--accent": key === 'sick' ? '#3b82f6' : (remaining < 0 ? '#ff4d4d' : '#8b5cf6') }}
                        >
                            <span className="stat-label">
                                {key.toUpperCase()} {isProbation ? '(PROBATION)' : 'REMAINING'}
                            </span>

                            <h1 className="big-stat-text">
                                {remaining % 1 === 0 ? remaining : remaining.toFixed(1)}
                            </h1>

                            <div className="stat-footer">
                                Used: {leaveBalances[key].used} / {leaveBalances[key].total}
                            </div>
                        </div>
                    );
                })}

                {/* CALENDAR CARD */}
                <div className="stat-highlight glass calendar-card">
                    <FullCalendar
                        ref={calendarRef}
                        key={calendarKey}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        events={calendarEvents}
                        height="auto"
                        expandRows={true}
                        fixedWeekCount={false}
                        headerToolbar={{
                            left: "prev,next",
                            center: "title",
                            right: "today"
                        }}
                        eventContent={(info) => {

                            const color = info.event.extendedProps.color;

                            return (
                                <div className="leave-circle" style={{ backgroundColor: color }}>
                                    {info.event.title}
                                </div>
                            );
                        }}
                    />

                    <div className="calendar-legend">
                        <span className="legend approved"></span> Approved
                        <span className="legend pending"></span> Pending
                        <span className="legend rejected"></span> Rejected
                        <span className="legend wfh"></span> WFH
                    </div>
                </div>

            </div>








            <div className="attendance-layout">

                <div className="panel glass">
                    <div className="panel-header">
                        <h3 className="panel-title">{editingId ? "Update Request" : "New Request"}</h3>
                        <span className="deduction-badge">{deduction} Units</span>
                    </div>
                    <form onSubmit={handleLeaveSubmit}>
                        <div className="input-group">
                            <label className="attendance-form-label">CATEGORY</label>
                            <select className="cyber-select" value={leaveForm.type} onChange={(e) => setLeaveForm({ ...leaveForm, type: e.target.value })}>
                                <option value="Sick Leave">Sick Leave</option>
                                <option value="Earned Leave">Earned Leave</option>
                            </select>
                        </div>
                        {/* <div className="input-row">
                            <div className="input-group"><label>START</label><input type="date" className="cyber-input" required value={leaveForm.start} onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })} /></div>
                            <div className="input-group"><label>END</label><input type="date" className="cyber-input" required min={leaveForm.start} value={leaveForm.end} onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })} /></div>
                        </div> */}

                        <div className="input-row">
                            <div className="input-group">
                                <label className="attendance-form-label">START</label>

                                <div className="date-input-wrapper">
                                    <input
                                        ref={startRef}
                                        type="date"
                                        className="cyber-input"
                                        required
                                        value={leaveForm.start}
                                        onChange={(e) => setLeaveForm({ ...leaveForm, start: e.target.value })}
                                        onClick={() => {
                                            try {
                                                if (startRef.current?.showPicker) {
                                                    startRef.current.showPicker();
                                                }
                                            } catch (err) {}
                                        }}
                                    />

                                    <span
                                        className="calendar-glow-icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            try {
                                                if (startRef.current?.showPicker) {
                                                    startRef.current.showPicker();
                                                } else {
                                                    startRef.current?.focus();
                                                }
                                            } catch (err) {
                                                startRef.current?.focus();
                                            }
                                        }}
                                    >
                                        📅
                                    </span>
                                </div>
                            </div>

                            <div className="input-group">
                                <label className="attendance-form-label">END</label>

                                <div className="date-input-wrapper">
                                    <input
                                        ref={endRef}
                                        type="date"
                                        className="cyber-input"
                                        required
                                        min={leaveForm.start}
                                        value={leaveForm.end}
                                        onChange={(e) => setLeaveForm({ ...leaveForm, end: e.target.value })}
                                        onClick={() => {
                                            try {
                                                if (endRef.current?.showPicker) {
                                                    endRef.current.showPicker();
                                                }
                                            } catch (err) {}
                                        }}
                                    />

                                    <span
                                        className="calendar-glow-icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            try {
                                                if (endRef.current?.showPicker) {
                                                    endRef.current.showPicker();
                                                } else {
                                                    endRef.current?.focus();
                                                }
                                            } catch (err) {
                                                endRef.current?.focus();
                                            }
                                        }}
                                    >
                                        📅
                                    </span>
                                </div>
                            </div>
                        </div>


                        {(leaveForm.type === 'Sick Leave' && isBackdated(leaveForm.start) && deduction > 2 && !isLeaveInProbation(leaveForm.start)) && (
                            <div className="input-group animate-fade" style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '10px', borderRadius: '5px', border: '1px solid #3b82f6' }}>
                                <label style={{ color: '#d6dce6' }}>⚠️ MEDICAL PROOF REQUIRED </label>
                                <input
                                    type="file"
                                    className="cyber-input"
                                    onChange={(e) => setMedicalFile(e.target.files[0])}
                                    accept=".pdf,.jpg,.png,.jpeg"
                                />
                                <small style={{ color: '#d3cbcb', fontSize: '14px' }}>Upload your medical certificate for verification.</small>
                            </div>
                        )}

                        <div className="input-group"><label className="attendance-form-label">REASON</label><textarea className="cyber-input" required value={leaveForm.reason} onChange={(e) => setLeaveForm({ ...leaveForm, reason: e.target.value })} /></div>
                        {penaltyMsg && <div className="penalty-alert">⚠️ {penaltyMsg}</div>}
                        <button type="submit" className="submit-btn" disabled={isSubmitting}>{isSubmitting ? "PROCESSING..." : (editingId ? "UPDATE / SAVE" : "APPLY LEAVE")}</button>
                    </form>
                </div>



                <div className="panel glass">
                    <h3 className="panel-title">Application Log</h3>
                    <div className="table-scroll">
                        <table className="history-table">
                            <thead>
                                <tr>
                                    <th>SR.NO</th>
                                    <th>TYPE</th>
                                    <th>FROM</th>
                                    <th>TO</th>
                                    <th>UNIT</th>
                                    <th>STATUS</th>
                                    <th>DOCUMENTATION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* {leaveHistory.map((log, i) => { */}
                                {displayLogs.map((log, i) => {
                                    const isApproved = String(log.Status) === '1';
                                    const isPending = String(log.Status) === '0';
                                    const isOver = new Date() > new Date(log.todate);
                                    const hasFile = (log.medical_doc && log.medical_doc.trim() !== "") || (log.proof && log.proof.trim() !== "");
                                    const timer = getTimerData(log.todate);
                                    const medStatus = String(log.medical_doc_status);

                                    // 1. TYPE LOGIC: Show only "Sick" or "Earned"
                                    const displayType = (log.leavetype === 'Earned Leave' && medStatus === '1')
                                        ? 'Sick'
                                        : log.leavetype.replace(' Leave', '');

                                    // 2. DATE LOGIC: Show as "29/1"
                                    const formatShortDate = (dateStr) => {
                                        const d = new Date(dateStr);
                                        if (isNaN(d)) return "-";
                                        return `${d.getDate()}/${d.getMonth() + 1}`;
                                    };

                                    return (
                                        <tr key={log.id || i}>
                                            <td>{String(i + 1).padStart(2, '')}</td>

                                            {/* Simplified Type: Sick or Earned */}
                                            <td style={{ fontWeight: '500' }}>{displayType}</td>

                                            {/* Date/Month only */}
                                            <td>{formatShortDate(log.fromdate)}</td>
                                            <td>{formatShortDate(log.todate)}</td>

                                            {/* Unit only (e.g., 3, 0.5) */}
                                            <td style={{ fontWeight: 'bold' }}>{parseFloat(log.total)}</td>

                                            <td>
                                                <span className={`status-pill ${isApproved ? 'approved' : (String(log.Status) === '2' ? 'rejected' : 'pending')}`}>
                                                    {isApproved ? 'Approved' : (String(log.Status) === '2' ? 'Rejected' : 'Pending')}
                                                </span>
                                            </td>
                                            <td>
                                                {isPending && (
                                                    <div className="action-btns">
                                                        <button className="edit-btn" onClick={() => handleModifyLeave(log)}>✎</button>
                                                        <button className="del-btn" onClick={() => handleDeleteLeave(log.id)}>✕</button>
                                                    </div>
                                                )}

                                                {isApproved &&
                                                    log.leavetype === 'Earned Leave' &&   // ✅ because sick>2 becomes earned
                                                    parseFloat(log.total) > 2 &&          // ✅ only >2 days
                                                    isOver &&
                                                    !hasFile &&
                                                    !timer.expired &&
                                                    !isProbation && (
                                                        <div className="upload-cell">
                                                            <span className="countdown-timer">⏳ {timer.text}</span>
                                                            <label className="action-upload">
                                                                Upload
                                                                <input
                                                                    type="file"
                                                                    hidden
                                                                    onChange={(e) => handleFileUpload(e, log.id)}
                                                                    accept=".pdf,.jpg,.png"
                                                                />
                                                            </label>
                                                        </div>
                                                    )}
                                                {hasFile && medStatus === '0' && <span className="status-pill pending">⏳ PENDING VERIFICATION</span>}
                                                {hasFile && medStatus === '1' && <span className="verified-badge"> Sick</span>}
                                                {hasFile && medStatus === '2' && <span className="status-pill rejected">Earned</span>}
                                                {/* {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="expired-label">❌ Expired (Earned)</span>} */}
                                                {isApproved && log.leavetype === 'Earned Leave' && isOver && !hasFile && timer.expired && <span className="status-pill rejected">Earned</span>}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Attendance;








